import { markRaw as tt, defineComponent as wt, computed as re, inject as Pe, watch as he, h as Ke, getCurrentInstance as ut, watchEffect as te, reactive as Ee, onMounted as cr, onUnmounted as fn, ref as z, provide as cn, toRef as pn, onBeforeUnmount as mn, nextTick as dn, triggerRef as De, isRef as ft, isReactive as Vt, createTextVNode as yn, resolveComponent as vn } from "vue";
var pr = [
  "__key",
  "__init",
  "__shim",
  "__original",
  "__index",
  "__prevKey"
];
function xe() {
  return Math.random().toString(36).substring(2, 15);
}
function hn(e, t) {
  const r = e instanceof Set ? e : new Set(e);
  return t && t.forEach((n) => r.add(n)), [...r];
}
function C(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function q(e, t, r = !0, n = ["__key"]) {
  if (e === t)
    return !0;
  if (typeof t == "object" && typeof e == "object") {
    if (e instanceof Map || e instanceof Set)
      return !1;
    if (e instanceof Date && t instanceof Date)
      return e.getTime() === t.getTime();
    if (e instanceof RegExp && t instanceof RegExp)
      return gn(e, t);
    if (e === null || t === null || Object.keys(e).length !== Object.keys(t).length)
      return !1;
    for (const s of n)
      if ((s in e || s in t) && e[s] !== t[s])
        return !1;
    for (const s in e)
      if (!(s in t) || e[s] !== t[s] && !r || r && !q(e[s], t[s], r, n))
        return !1;
    return !0;
  }
  return !1;
}
function gn(e, t) {
  return e.source === t.source && e.flags.split("").sort().join("") === t.flags.split("").sort().join("");
}
function B(e) {
  const t = typeof e;
  if (t === "number")
    return !1;
  if (e === void 0)
    return !0;
  if (t === "string")
    return e === "";
  if (t === "object") {
    if (e === null)
      return !0;
    for (const r in e)
      return !1;
    return !(e instanceof RegExp || e instanceof Date);
  }
  return !1;
}
function bn(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $n(e) {
  const t = `^${bn(e)}$`, r = {
    MM: "(0[1-9]|1[012])",
    M: "([1-9]|1[012])",
    DD: "([012][0-9]|3[01])",
    D: "([012]?[0-9]|3[01])",
    YYYY: "\\d{4}",
    YY: "\\d{2}"
  }, n = Object.keys(r);
  return new RegExp(
    n.reduce((s, i) => s.replace(i, r[i]), t)
  );
}
function He(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Ie(e) {
  return He(e) || Array.isArray(e);
}
function we(e) {
  if (He(e) === !1 || e.__FKNode__ || e.__POJO__ === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const r = t.prototype;
  return !(He(r) === !1 || r.hasOwnProperty("isPrototypeOf") === !1);
}
var ae = /* @__NO_SIDE_EFFECTS__ */ (e, t, r = !1, n = !1) => {
  if (t === null)
    return null;
  const s = {};
  if (typeof t == "string")
    return t;
  for (const i in e)
    if (C(t, i) && (t[i] !== void 0 || !n)) {
      if (r && Array.isArray(e[i]) && Array.isArray(t[i])) {
        s[i] = e[i].concat(t[i]);
        continue;
      }
      if (t[i] === void 0)
        continue;
      we(e[i]) && we(t[i]) ? s[i] = /* @__PURE__ */ ae(
        e[i],
        t[i],
        r,
        n
      ) : s[i] = t[i];
    } else
      s[i] = e[i];
  for (const i in t)
    !C(s, i) && t[i] !== void 0 && (s[i] = t[i]);
  return s;
};
function _n(e) {
  if (e[0] !== '"' && e[0] !== "'" || e[0] !== e[e.length - 1])
    return !1;
  const t = e[0];
  for (let r = 1; r < e.length; r++)
    if (e[r] === t && (r === 1 || e[r - 1] !== "\\") && r !== e.length - 1)
      return !1;
  return !0;
}
function wn(e) {
  if (!e.length)
    return "";
  let t = "", r = "";
  for (let n = 0; n < e.length; n++) {
    const s = e.charAt(n);
    (s !== "\\" || r === "\\") && (t += s), r = s;
  }
  return t;
}
function de(...e) {
  return e.reduce((t, r) => {
    const { value: n, name: s, modelValue: i, config: a, plugins: l, ...o } = r;
    return Object.assign(t, o);
  }, {});
}
function kn(e) {
  const t = [];
  let r = "", n = 0, s = "", i = "";
  for (let a = 0; a < e.length; a++) {
    const l = e.charAt(a);
    l === s && i !== "\\" ? s = "" : (l === "'" || l === '"') && !s && i !== "\\" ? s = l : l === "(" && !s ? n++ : l === ")" && !s && n--, l === "," && !s && n === 0 ? (t.push(r), r = "") : (l !== " " || s) && (r += l), i = l;
  }
  return r && t.push(r), t;
}
function Nt(e, t) {
  const r = {}, n = t.filter((i) => i instanceof RegExp), s = new Set(t);
  for (const i in e)
    !s.has(i) && !n.some((a) => a.test(i)) && (r[i] = e[i]);
  return r;
}
function Ft(e, t) {
  const r = {}, n = t.filter((s) => s instanceof RegExp);
  return t.forEach((s) => {
    s instanceof RegExp || (r[s] = e[s]);
  }), Object.keys(e).forEach((s) => {
    n.some((i) => i.test(s)) && (r[s] = e[s]);
  }), r;
}
function ge(e) {
  return e.replace(
    /-([a-z0-9])/gi,
    (t, r) => r.toUpperCase()
  );
}
function mr(e) {
  return e.replace(
    /([a-z0-9])([A-Z])/g,
    (t, r, n) => r + "-" + n.toLowerCase()
  ).replace(" ", "-").toLowerCase();
}
function ct(e, t = pr) {
  if (e !== null && typeof e == "object") {
    let r;
    if (Array.isArray(e) ? r = [...e] : we(e) && (r = { ...e }), r)
      return An(e, r, t), r;
  }
  return e;
}
function ke(e, t = pr) {
  if (e === null || e instanceof RegExp || e instanceof Date || e instanceof Map || e instanceof Set || typeof File == "function" && e instanceof File)
    return e;
  let r;
  Array.isArray(e) ? r = e.map((n) => typeof n == "object" ? ke(n, t) : n) : r = Object.keys(e).reduce((n, s) => (n[s] = typeof e[s] == "object" ? ke(e[s], t) : e[s], n), {});
  for (const n of t)
    n in e && Object.defineProperty(r, n, {
      enumerable: !1,
      value: e[n]
    });
  return r;
}
function H(e) {
  return typeof e == "object" ? ke(e) : e;
}
function Sn(e, t) {
  if (!e || typeof e != "object")
    return null;
  const r = t.split(".");
  let n = e;
  for (const s in r) {
    const i = r[s];
    if (C(n, i) && (n = n[i]), +s === r.length - 1)
      return n;
    if (!n || typeof n != "object")
      return null;
  }
  return null;
}
function U(e) {
  return e !== void 0 && e !== "false" && e !== !1 ? !0 : void 0;
}
function Se(e) {
  return Object.isFrozen(e) ? e : Object.defineProperty(e, "__init", {
    enumerable: !1,
    value: !0
  });
}
function kt(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, " ").trim().replace(/\s+/g, "-");
}
function An(e, t, r) {
  for (const n of r)
    n in e && Object.defineProperty(t, n, {
      enumerable: !1,
      value: e[n]
    });
  return t;
}
function xn(e) {
  let t = !1;
  return (...r) => {
    if (!t)
      return t = !0, queueMicrotask(() => t = !1), e(...r);
  };
}
function Cn(e) {
  if (!(e === "false" || e === !1))
    return !0;
}
function St() {
  const e = [];
  let t = 0;
  const r = (s) => e.push(s), n = (s) => {
    const i = e[t];
    return typeof i == "function" ? i(s, (a) => (t++, n(a))) : (t = 0, s);
  };
  return r.dispatch = n, r.unshift = (s) => e.unshift(s), r.remove = (s) => {
    const i = e.indexOf(s);
    i > -1 && e.splice(i, 1);
  }, r;
}
function dr() {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  let r;
  const n = (s, i) => {
    if (r) {
      r.set(i.name, [s, i]);
      return;
    }
    e.has(i.name) && e.get(i.name).forEach((a) => {
      (i.origin === s || a.modifiers.includes("deep")) && a.listener(i);
    }), i.bubble && s.bubble(i);
  };
  return n.flush = () => {
    e.clear(), t.clear(), r == null || r.clear();
  }, n.on = (s, i, a = "push") => {
    const [l, ...o] = s.split("."), y = i.receipt || xe(), v = {
      modifiers: o,
      event: l,
      listener: i,
      receipt: y
    };
    return e.has(l) ? e.get(l)[a](v) : e.set(l, [v]), t.has(y) ? t.get(y)[a](l) : t.set(y, [l]), y;
  }, n.off = (s) => {
    var i;
    t.has(s) && ((i = t.get(s)) == null || i.forEach((a) => {
      const l = e.get(a);
      Array.isArray(l) && e.set(
        a,
        l.filter((o) => o.receipt !== s)
      );
    }), t.delete(s));
  }, n.pause = (s) => {
    r || (r = /* @__PURE__ */ new Map()), s && s.walk((i) => i._e.pause());
  }, n.play = (s) => {
    if (!r)
      return;
    const i = r;
    r = void 0, i.forEach(([a, l]) => n(a, l)), s && s.walk((a) => a._e.play());
  }, n;
}
function Pn(e, t, r, n, s = !0, i) {
  return t._e(e, {
    payload: n,
    name: r,
    bubble: s,
    origin: e,
    meta: i
  }), e;
}
function En(e, t, r) {
  return Ve(e.parent) && e.parent._e(e.parent, r), e;
}
function On(e, t, r, n, s) {
  return t._e.on(r, n, s);
}
function Mn(e, t, r) {
  return t._e.off(r), e;
}
var At = St();
At((e, t) => (e.message || (e.message = `E${e.code}`), t(e)));
var xt = St();
xt((e, t) => {
  e.message || (e.message = `W${e.code}`);
  const r = t(e);
  return console && typeof console.warn == "function" && console.warn(r.message), r;
});
function je(e, t = {}) {
  xt.dispatch({ code: e, data: t });
}
function W(e, t = {}) {
  throw Error(At.dispatch({ code: e, data: t }).message);
}
function K(e, t) {
  const r = {
    blocking: !1,
    key: xe(),
    meta: {},
    type: "state",
    visible: !0,
    ...e
  };
  return t && r.value && r.meta.localize !== !1 && (r.value = t.t(r), r.meta.locale = t.config.locale), r;
}
var Dt = {
  apply: Fn,
  set: Rn,
  remove: yr,
  filter: Vn,
  reduce: Nn,
  release: qn,
  touch: jn
};
function In(e = !1) {
  const t = {};
  let r, n = e, s = [];
  const i = /* @__PURE__ */ new Map();
  let a;
  const l = new Proxy(t, {
    get(...o) {
      const [y, v] = o;
      return v === "buffer" ? n : v === "_b" ? s : v === "_m" ? i : v === "_r" ? a : C(Dt, v) ? Dt[v].bind(
        null,
        t,
        l,
        r
      ) : Reflect.get(...o);
    },
    set(o, y, v) {
      return y === "_n" ? (r = v, a === "__n" && vr(r, l), !0) : y === "_b" ? (s = v, !0) : y === "buffer" ? (n = v, !0) : y === "_r" ? (a = v, !0) : (W(101, r), !1);
    }
  });
  return l;
}
function Rn(e, t, r, n) {
  if (t.buffer)
    return t._b.push([[n]]), t;
  if (e[n.key] !== n) {
    if (typeof n.value == "string" && n.meta.localize !== !1) {
      const i = n.value;
      n.value = r.t(n), n.value !== i && (n.meta.locale = r.props.locale);
    }
    const s = `message-${C(e, n.key) ? "updated" : "added"}`;
    e[n.key] = Object.freeze(
      r.hook.message.dispatch(n)
    ), r.emit(s, n);
  }
  return t;
}
function jn(e, t) {
  for (const r in e) {
    const n = { ...e[r] };
    t.set(n);
  }
}
function yr(e, t, r, n) {
  if (C(e, n)) {
    const s = e[n];
    delete e[n], r.emit("message-removed", s);
  }
  return t.buffer === !0 && (t._b = t._b.filter((s) => (s[0] = s[0].filter((i) => i.key !== n), s[1] || s[0].length))), t;
}
function Vn(e, t, r, n, s) {
  for (const i in e) {
    const a = e[i];
    (!s || a.type === s) && !n(a) && yr(e, t, r, i);
  }
}
function Nn(e, t, r, n, s) {
  for (const i in e) {
    const a = e[i];
    s = n(s, a);
  }
  return s;
}
function Fn(e, t, r, n, s) {
  if (Array.isArray(n)) {
    if (t.buffer) {
      t._b.push([n, s]);
      return;
    }
    const i = new Set(
      n.map((a) => (t.set(a), a.key))
    );
    typeof s == "string" ? t.filter(
      (a) => a.type !== s || i.has(a.key)
    ) : typeof s == "function" && t.filter((a) => !s(a) || i.has(a.key));
  } else
    for (const i in n) {
      const a = r.at(i);
      a ? a.store.apply(n[i], s) : Ln(r, t, i, n[i], s);
    }
}
function Dn(e, ...t) {
  const r = `${e.name}-set`, n = (s) => /* @__PURE__ */ K({
    key: kt(s),
    type: "error",
    value: s,
    meta: { source: r, autoClear: !0 }
  });
  return t.filter((s) => !!s).map((s) => {
    if (typeof s == "string" && (s = [s]), Array.isArray(s))
      return s.map((i) => n(i));
    {
      const i = {};
      for (const a in s)
        Array.isArray(s[a]) ? i[a] = s[a].map(
          (l) => n(l)
        ) : i[a] = [n(s[a])];
      return i;
    }
  });
}
function Ln(e, t, r, n, s) {
  var a;
  const i = t._m;
  i.has(r) || i.set(r, []), t._r || (t._r = vr(e, t)), (a = i.get(r)) == null || a.push([n, s]);
}
function vr(e, t) {
  return e.on(
    "child.deep",
    ({ payload: r }) => {
      t._m.forEach((n, s) => {
        e.at(s) === r && (n.forEach(([i, a]) => {
          r.store.apply(i, a);
        }), t._m.delete(s));
      }), t._m.size === 0 && t._r && (e.off(t._r), t._r = void 0);
    }
  );
}
function qn(e, t) {
  t.buffer = !1, t._b.forEach(([r, n]) => t.apply(r, n)), t._b = [];
}
function Tn() {
  const e = {};
  let t;
  return {
    count: (...r) => zn(t, e, ...r),
    init(r) {
      t = r, r.on("message-added.deep", Lt(e, 1)), r.on("message-removed.deep", Lt(e, -1));
    },
    merge: (r) => qt(t, e, r),
    settled(r) {
      return C(e, r) ? e[r].promise : Promise.resolve();
    },
    unmerge: (r) => qt(t, e, r, !0),
    value(r) {
      return C(e, r) ? e[r].count : 0;
    }
  };
}
function zn(e, t, r, n, s = 0) {
  if (n = Wn(n || r), !C(t, r)) {
    const i = {
      condition: n,
      count: 0,
      name: r,
      node: e,
      promise: Promise.resolve(),
      resolve: () => {
      }
      // eslint-disable-line @typescript-eslint/no-empty-function
    };
    t[r] = i, s = e.store.reduce(
      (a, l) => a + i.condition(l) * 1,
      s
    ), e.each((a) => {
      a.ledger.count(i.name, i.condition), s += a.ledger.value(i.name);
    });
  }
  return hr(t[r], s).promise;
}
function Wn(e) {
  return typeof e == "function" ? e : (t) => t.type === e;
}
function hr(e, t) {
  const r = e.count, n = e.count + t;
  return e.count = n, r === 0 && n !== 0 ? (e.node.emit(`unsettled:${e.name}`, e.count, !1), e.promise = new Promise((s) => e.resolve = s)) : r !== 0 && n === 0 && (e.node.emit(`settled:${e.name}`, e.count, !1), e.resolve()), e.node.emit(`count:${e.name}`, e.count, !1), e;
}
function Lt(e, t) {
  return (r) => {
    for (const n in e) {
      const s = e[n];
      s.condition(r.payload) && hr(s, t);
    }
  };
}
function qt(e, t, r, n = !1) {
  const s = e;
  for (const i in t) {
    const a = t[i].condition;
    n || r.ledger.count(i, a);
    const l = r.ledger.value(i) * (n ? -1 : 1);
    if (e) {
      do
        e.ledger.count(i, a, l), e = e.parent;
      while (e);
      e = s;
    }
  }
}
var Ct = /* @__PURE__ */ new Map(), qe = /* @__PURE__ */ new Map(), Pt = dr();
function Kn(e) {
  e.props.id && (Ct.set(e.props.id, e), qe.set(e, e.props.id), Pt(e, {
    payload: e,
    name: e.props.id,
    bubble: !1,
    origin: e
  }));
}
function Hn(e) {
  if (qe.has(e)) {
    const t = qe.get(e);
    qe.delete(e), Ct.delete(t), Pt(e, {
      payload: null,
      name: t,
      bubble: !1,
      origin: e
    });
  }
}
function gr(e) {
  return Ct.get(e);
}
function Un(e, t) {
  return Pt.on(e, t);
}
function Tt(e, t, r) {
  let n = !0;
  return t in e.config._t ? n = !1 : e.emit(`config:${t}`, r, !1), t in e.props || (e.emit("prop", { prop: t, value: r }), e.emit(`prop:${t}`, r)), n;
}
function Bn(e, t) {
  const r = (t || document).getElementById(e);
  if (r instanceof HTMLFormElement) {
    const n = new Event("submit", { cancelable: !0, bubbles: !0 });
    r.dispatchEvent(n);
    return;
  }
  je(151, e);
}
function Zn(e) {
  const t = (r) => {
    for (const n in r.store) {
      const s = r.store[n];
      s.type === "error" || s.type === "ui" && n === "incomplete" ? r.store.remove(n) : s.type === "state" && r.store.set({ ...s, value: !1 });
    }
  };
  t(e), e.walk(t);
}
function Yn(e, t) {
  const r = typeof e == "string" ? gr(e) : e;
  if (r) {
    const n = (a) => H(a.props.initial) || (a.type === "group" ? {} : a.type === "list" ? [] : void 0);
    r._e.pause(r);
    const s = H(t);
    return t && !B(t) && (r.props.initial = Ie(s) ? Se(s) : s, r.props._init = r.props.initial), r.input(n(r), !1), r.walk((a) => {
      a.type === "list" && a.sync || a.input(n(a), !1);
    }), r.input(
      B(s) && s ? s : n(r),
      !1
    ), r.type !== "input" && t && !B(t) && Ie(t) && r.walk((a) => {
      a.props.initial = Ie(a.value) ? Se(a.value) : a.value, a.props._init = a.props.initial;
    }), r._e.play(r), Zn(r), r.emit("reset", r), r;
  }
  je(152, e);
}
var Jn = {
  delimiter: ".",
  delay: 0,
  locale: "en",
  rootClasses: (e) => ({ [`formkit-${mr(e)}`]: !0 })
}, br = Symbol("index"), pt = Symbol("removed"), mt = Symbol("moved"), $r = Symbol("inserted");
function Gn(e) {
  return e.type === "list" && Array.isArray(e._value);
}
function Ve(e) {
  return e && typeof e == "object" && e.__FKNode__ === !0;
}
var Te = (e, t, r) => {
  W(102, [e, r]);
}, Qn = {
  _c: I(bs, Te, !1),
  add: I(cs),
  addProps: I(fs),
  address: I(_s, Te, !1),
  at: I(ws),
  bubble: I(En),
  clearErrors: I(Ms),
  calm: I(ls),
  config: I(!1),
  define: I(us),
  disturb: I(as),
  destroy: I(os),
  extend: I(Rs),
  hydrate: I(ss),
  index: I(gs, hs, !1),
  input: I(kr),
  each: I(ds),
  emit: I(Pn),
  find: I(Ss),
  on: I(On),
  off: I(Mn),
  parent: I(!1, ps),
  plugins: I(!1),
  remove: I(ms),
  root: I(xs, Te, !1),
  reset: I(Es),
  resetConfig: I(vs),
  setErrors: I(Os),
  submit: I(Ps),
  t: I(Cs),
  use: I(Et),
  name: I($s, !1, !1),
  walk: I(ys)
};
function Xn() {
  return new Map(Object.entries(Qn));
}
function I(e, t, r = !0) {
  return {
    get: e ? (n, s) => r ? (...i) => e(n, s, ...i) : e(n, s) : !1,
    set: t !== void 0 ? t : Te.bind(null)
  };
}
function es() {
  const e = /* @__PURE__ */ new Map();
  return new Proxy(e, {
    get(t, r) {
      return e.has(r) || e.set(r, St()), e.get(r);
    }
  });
}
var _r = 0, ts = 0;
function rs(e) {
  var t, r;
  return ((t = e.parent) == null ? void 0 : t.type) === "list" ? br : e.name || `${((r = e.props) == null ? void 0 : r.type) || "input"}_${++_r}`;
}
function wr(e) {
  return e.type === "group" ? Se(
    e.value && typeof e.value == "object" && !Array.isArray(e.value) ? e.value : {}
  ) : e.type === "list" ? Se(Array.isArray(e.value) ? e.value : []) : e.value;
}
function kr(e, t, r, n = !0) {
  return t._value = ns(e, e.hook.input.dispatch(r)), e.emit("input", t._value), e.isCreated && e.type === "input" && q(t._value, t.value) && !e.props.mergeStrategy ? (e.emit("commitRaw", t.value), t.settled) : (t.isSettled && e.disturb(), n ? (t._tmo && clearTimeout(t._tmo), t._tmo = setTimeout(
    Ue,
    e.props.delay,
    e,
    t
  )) : Ue(e, t), t.settled);
}
function ns(e, t) {
  switch (e.type) {
    case "input":
      break;
    case "group":
      (!t || typeof t != "object") && W(107, [e, t]);
      break;
    case "list":
      Array.isArray(t) || W(108, [e, t]);
      break;
  }
  return t;
}
function Ue(e, t, r = !0, n = !0) {
  t._value = t.value = e.hook.commit.dispatch(t._value), e.type !== "input" && n && e.hydrate(), e.emit("commitRaw", t.value), e.emit("commit", t.value), r && e.calm();
}
function Sr(e, { name: t, value: r, from: n }) {
  if (!Object.isFrozen(e._value)) {
    if (Gn(e)) {
      const s = r === pt ? [] : r === mt && typeof n == "number" ? e._value.splice(n, 1) : [r];
      e._value.splice(
        t,
        r === mt || n === $r ? 0 : 1,
        ...s
      );
      return;
    }
    r !== pt ? e._value[t] = r : delete e._value[t];
  }
}
function ss(e, t) {
  const r = t._value;
  return e.type === "list" && e.sync && is(e, t), t.children.forEach((n) => {
    if (typeof r == "object")
      if (n.name in r) {
        const s = n.type !== "input" || r[n.name] && typeof r[n.name] == "object" ? Se(r[n.name]) : r[n.name];
        if (!n.isSettled || (!Ie(s) || n.props.mergeStrategy) && q(s, n._value))
          return;
        n.input(s, !1);
      } else
        (e.type !== "list" || typeof n.name == "number") && Sr(t, { name: n.name, value: n.value }), r.__init || (n.type === "group" ? n.input({}, !1) : n.type === "list" ? n.input([], !1) : n.input(void 0, !1));
  }), e;
}
function is(e, t) {
  const r = e._value;
  if (!Array.isArray(r))
    return;
  const n = [], s = new Set(t.children), i = /* @__PURE__ */ new Map();
  r.forEach((l, o) => {
    if (t.children[o] && t.children[o]._value === l)
      n.push(t.children[o]), s.delete(t.children[o]);
    else {
      n.push(null);
      const y = i.get(l) || [];
      y.push(o), i.set(l, y);
    }
  }), s.size && i.size && s.forEach((l) => {
    if (i.has(l._value)) {
      const o = i.get(l._value), y = o.shift();
      n[y] = l, s.delete(l), o.length || i.delete(l._value);
    }
  });
  const a = [];
  for (i.forEach((l) => {
    a.push(...l);
  }); s.size && a.length; ) {
    const l = s.values().next().value, o = a.shift();
    if (o === void 0)
      break;
    n[o] = l, s.delete(l);
  }
  a.forEach((l, o) => {
    n[l] = Fs({ value: o });
  }), s.size && s.forEach((l) => {
    if (!("__FKP" in l)) {
      const o = l._c.parent;
      if (!o || Ds(o))
        return;
      o.ledger.unmerge(l), l._c.parent = null, l.destroy();
    }
  }), t.children = n;
}
function as(e, t) {
  var r;
  return t._d <= 0 && (t.isSettled = !1, e.emit("settled", !1, !1), t.settled = new Promise((n) => {
    t._resolve = n;
  }), e.parent && ((r = e.parent) == null || r.disturb())), t._d++, e;
}
function ls(e, t, r) {
  var n;
  if (r !== void 0 && e.type !== "input") {
    Sr(t, r);
    const s = !!(e.config.mergeStrategy && e.config.mergeStrategy[r.name]);
    return Ue(e, t, !0, s);
  }
  t._d > 0 && t._d--, t._d === 0 && (t.isSettled = !0, e.emit("settled", !0, !1), e.parent && ((n = e.parent) == null || n.calm({ name: e.name, value: t.value })), t._resolve && t._resolve(t.value));
}
function os(e, t) {
  e.emit("destroying", e), e.store.filter(() => !1), e.parent && e.parent.remove(e), Hn(e), e.emit("destroyed", e), t._e.flush(), t._value = t.value = void 0;
  for (const r in t.context)
    delete t.context[r];
  t.plugins.clear(), t.context = null;
}
function us(e, t, r) {
  t.type = r.type;
  const n = ke(r);
  e.props.__propDefs = Ar(
    e.props.__propDefs ?? [],
    (n == null ? void 0 : n.props) || []
  ), n.props = e.props.__propDefs, t.props.definition = n, t.value = t._value = wr({
    type: e.type,
    value: t.value
  }), r.forceTypeProp && (e.props.type && (e.props.originalType = e.props.type), t.props.type = r.forceTypeProp), r.family && (t.props.family = r.family), r.features && r.features.forEach((s) => s(e)), r.props && e.addProps(r.props), e.emit("defined", r);
}
function fs(e, t, r) {
  const n = Array.isArray(r) ? r : Object.keys(r), s = Array.isArray(r) ? {} : n.reduce((a, l) => ("default" in r[l] && (a[l] = r[l].default), a), {});
  if (e.props.attrs) {
    const a = { ...e.props.attrs };
    e.props._emit = !1;
    for (const o in a) {
      const y = ge(o);
      n.includes(y) && (e.props[y] = a[o], delete a[o]);
    }
    Array.isArray(r) || n.forEach((o) => {
      "default" in r[o] && e.props[o] === void 0 && (e.props[o] = s[o]);
    });
    const l = H(t._value);
    e.props.initial = e.type !== "input" ? Se(l) : l, e.props._emit = !0, e.props.attrs = a;
  }
  const i = Ar(e.props.__propDefs ?? [], r);
  return e.props.definition && (e.props.definition.props = i), e.props.__propDefs = i, e.emit("added-props", r), e;
}
function dt(e) {
  return Array.isArray(e) ? e.reduce((t, r) => (t[r] = {}, t), {}) : e;
}
function Ar(e, t) {
  return Array.isArray(e) && Array.isArray(t) ? e.concat(t) : ae(dt(e), dt(t));
}
function cs(e, t, r, n) {
  if (e.type === "input" && W(100, e), r.parent && r.parent !== e && r.parent.remove(r), !t.children.includes(r)) {
    if (n !== void 0 && e.type === "list") {
      const s = t.children[n];
      s && "__FKP" in s ? (r._c.uid = s.uid, t.children.splice(n, 1, r)) : t.children.splice(n, 0, r), Array.isArray(e.value) && e.value.length < t.children.length && e.disturb().calm({
        name: n,
        value: r.value,
        from: $r
      });
    } else
      t.children.push(r);
    r.isSettled || e.disturb();
  }
  if (r.parent !== e) {
    if (r.parent = e, r.parent !== e)
      return e.remove(r), r.parent.add(r), e;
  } else
    r.use(e.plugins);
  return Ue(e, t, !1), e.ledger.merge(r), e.emit("child", r), e;
}
function ps(e, t, r, n) {
  return Ve(n) ? (e.parent && e.parent !== n && e.parent.remove(e), t.parent = n, e.resetConfig(), n.children.includes(e) ? e.use(n.plugins) : n.add(e), !0) : n === null ? (t.parent = null, !0) : !1;
}
function ms(e, t, r) {
  const n = t.children.indexOf(r);
  if (n !== -1) {
    r.isSettled && e.disturb(), t.children.splice(n, 1);
    let s = U(r.props.preserve), i = r.parent;
    for (; s === void 0 && i; )
      s = U(i.props.preserve), i = i.parent;
    s ? e.calm() : e.calm({
      name: e.type === "list" ? n : r.name,
      value: pt
    }), r.parent = null, r.config._rmn = r;
  }
  return e.ledger.unmerge(r), e.emit("childRemoved", r), e;
}
function ds(e, t, r) {
  t.children.forEach((n) => !("__FKP" in n) && r(n));
}
function ys(e, t, r, n = !1, s = !1) {
  t.children.some((i) => {
    if ("__FKP" in i)
      return !1;
    const a = r(i);
    return n && a === !1 ? !0 : s && a === !1 ? !1 : i.walk(r, n, s);
  });
}
function vs(e, t) {
  const r = e.parent || void 0;
  t.config = xr(e.config._t, r), e.walk((n) => n.resetConfig());
}
function Et(e, t, r, n = !0, s = !0) {
  return Array.isArray(r) || r instanceof Set ? (r.forEach((i) => Et(e, t, i)), e) : (t.plugins.has(r) || (s && typeof r.library == "function" && r.library(e), n && r(e) !== !1 && (t.plugins.add(r), e.children.forEach((i) => i.use(r)))), e);
}
function hs(e, t, r, n) {
  if (Ve(e.parent)) {
    const s = e.parent.children, i = n >= s.length ? s.length - 1 : n < 0 ? 0 : n, a = s.indexOf(e);
    return a === -1 ? !1 : (s.splice(a, 1), s.splice(i, 0, e), e.parent.children = s, e.parent.type === "list" && e.parent.disturb().calm({ name: i, value: mt, from: a }), !0);
  }
  return !1;
}
function gs(e) {
  if (e.parent) {
    const t = [...e.parent.children].indexOf(e);
    return t === -1 ? e.parent.children.length : t;
  }
  return -1;
}
function bs(e, t) {
  return t;
}
function $s(e, t) {
  var r;
  return ((r = e.parent) == null ? void 0 : r.type) === "list" ? e.index : t.name !== br ? t.name : e.index;
}
function _s(e, t) {
  return t.parent ? t.parent.address.concat([e.name]) : [e.name];
}
function ws(e, t, r) {
  const n = typeof r == "string" ? r.split(e.config.delimiter) : r;
  if (!n.length)
    return;
  const s = n[0];
  let i = e.parent;
  for (i || (String(n[0]) === String(e.name) && n.shift(), i = e), s === "$parent" && n.shift(); i && n.length; ) {
    const a = n.shift();
    switch (a) {
      case "$root":
        i = e.root;
        break;
      case "$parent":
        i = i.parent;
        break;
      case "$self":
        i = e;
        break;
      default:
        i = i.children.find(
          (l) => !("__FKP" in l) && String(l.name) === String(a)
        ) || ks(i, a);
    }
  }
  return i || void 0;
}
function ks(e, t) {
  const r = String(t).match(/^(find)\((.*)\)$/);
  if (r) {
    const [, n, s] = r, i = s.split(",").map((a) => a.trim());
    switch (n) {
      case "find":
        return e.find(i[0], i[1]);
      default:
        return;
    }
  }
}
function Ss(e, t, r, n) {
  return As(e, r, n);
}
function As(e, t, r = "name") {
  const n = typeof r == "string" ? (i) => i[r] == t : r, s = [e];
  for (; s.length; ) {
    const i = s.shift();
    if (!("__FKP" in i)) {
      if (n(i, t))
        return i;
      s.push(...i.children);
    }
  }
}
function xs(e) {
  let t = e;
  for (; t.parent; )
    t = t.parent;
  return t;
}
function xr(e = {}, t) {
  let r;
  return new Proxy(e, {
    get(...n) {
      const s = n[1];
      if (s === "_t")
        return e;
      const i = Reflect.get(...n);
      if (i !== void 0)
        return i;
      if (t) {
        const a = t.config[s];
        if (a !== void 0)
          return a;
      }
      if (e.rootConfig && typeof s == "string") {
        const a = e.rootConfig[s];
        if (a !== void 0)
          return a;
      }
      return s === "delay" && (r == null ? void 0 : r.type) === "input" ? 20 : Jn[s];
    },
    set(...n) {
      const s = n[1], i = n[2];
      if (s === "_n")
        return r = i, e.rootConfig && e.rootConfig._add(r), !0;
      if (s === "_rmn")
        return e.rootConfig && e.rootConfig._rm(r), r = void 0, !0;
      if (!q(e[s], i, !1)) {
        const a = Reflect.set(...n);
        return r && (r.emit(`config:${s}`, i, !1), Tt(r, s, i), r.walk((l) => Tt(l, s, i), !1, !0)), a;
      }
      return !0;
    }
  });
}
function Cs(e, t, r, n = "ui") {
  const s = typeof r == "string" ? { key: r, value: r, type: n } : r, i = e.hook.text.dispatch(s);
  return e.emit("text", i, !1), i.value;
}
function Ps(e) {
  const t = e.name;
  do {
    if (e.props.isForm === !0)
      break;
    e.parent || W(106, t), e = e.parent;
  } while (e);
  e.props.id && Bn(e.props.id, e.props.__root);
}
function Es(e, t, r) {
  return Yn(e, r);
}
function Os(e, t, r, n) {
  const s = `${e.name}-set`, i = e.hook.setErrors.dispatch({ localErrors: r, childErrors: n });
  return Dn(e, i.localErrors, i.childErrors).forEach(
    (a) => {
      e.store.apply(a, (l) => l.meta.source === s);
    }
  ), e;
}
function Ms(e, t, r = !0, n) {
  return e.store.filter((s) => !(n === void 0 || s.meta.source === n), "error"), r && (n = n || `${e.name}-set`, e.walk((s) => {
    s.store.filter((i) => !(i.type === "error" && i.meta && i.meta.source === n));
  })), e;
}
function Is(e) {
  const t = {
    initial: typeof e == "object" ? H(e) : e
  };
  let r, n = !0, s = {};
  return new Proxy(t, {
    get(...i) {
      var v, g, E, h;
      const [a, l] = i;
      let o;
      C(t, l) ? (o = Reflect.get(...i), (v = s[l]) != null && v.boolean && (o = Cn(o))) : r && typeof l == "string" && r.config[l] !== void 0 ? (o = r.config[l], l === "mergeStrategy" && (r == null ? void 0 : r.type) === "input" && He(o) && r.name in o && (o = o[r.name])) : o = (g = s[l]) == null ? void 0 : g.default;
      const y = (E = s[l]) == null ? void 0 : E.getter;
      return (h = s[l]) != null && h.boolean && (o = !!o), y ? y(o, r) : o;
    },
    set(i, a, l, o) {
      var E;
      if (a === "_n")
        return r = l, !0;
      if (a === "_emit")
        return n = l, !0;
      let { prop: y, value: v } = r.hook.prop.dispatch({
        prop: a,
        value: l
      });
      const g = (E = s[y]) == null ? void 0 : E.setter;
      if (v = g ? g(v, r) : v, !q(t[y], v, !1) || typeof v == "object") {
        const h = Reflect.set(i, y, v, o);
        return y === "__propDefs" && (s = dt(v)), n && (r.emit("prop", { prop: y, value: v }), typeof y == "string" && r.emit(`prop:${y}`, v)), h;
      }
      return !0;
    }
  });
}
function Rs(e, t, r, n) {
  return t.traps.set(r, n), e;
}
function js(e, t) {
  if (e.props.definition)
    return e.define(e.props.definition);
  for (const r of t) {
    if (e.props.definition)
      return;
    typeof r.library == "function" && r.library(e);
  }
}
function Vs(e) {
  const t = wr(e), r = xr(e.config || {}, e.parent);
  return {
    _d: 0,
    _e: dr(),
    uid: Symbol(),
    _resolve: !1,
    _tmo: !1,
    _value: t,
    children: hn(e.children || []),
    config: r,
    hook: es(),
    isCreated: !1,
    isSettled: !0,
    ledger: Tn(),
    name: rs(e),
    parent: e.parent || null,
    plugins: /* @__PURE__ */ new Set(),
    props: Is(t),
    settled: Promise.resolve(t),
    store: In(!0),
    sync: e.sync || !1,
    traps: Xn(),
    type: e.type || "input",
    value: t
  };
}
function Ns(e, t) {
  var n, s;
  const r = (n = t.props) == null ? void 0 : n.id;
  if (r || (s = t.props) == null || delete s.id, e.ledger.init(e.store._n = e.props._n = e.config._n = e), e.props._emit = !1, Object.assign(
    e.props,
    r ? {} : { id: `input_${ts++}` },
    t.props ?? {}
  ), e.props._emit = !0, js(
    e,
    /* @__PURE__ */ new Set([
      ...t.plugins || [],
      ...e.parent ? e.parent.plugins : []
    ])
  ), t.plugins)
    for (const i of t.plugins)
      Et(e, e._c, i, !0, !1);
  return e.each((i) => e.add(i)), e.parent && e.parent.add(e, t.index), e.type === "input" && e.children.length && W(100, e), kr(e, e._c, e._value, !1), e.store.release(), r && Kn(e), e.emit("created", e), e.isCreated = !0, e;
}
function Fs(e) {
  return {
    __FKP: !0,
    uid: Symbol(),
    name: (e == null ? void 0 : e.name) ?? `p_${_r++}`,
    value: (e == null ? void 0 : e.value) ?? null,
    _value: (e == null ? void 0 : e.value) ?? null,
    type: (e == null ? void 0 : e.type) ?? "input",
    props: {},
    use: () => {
    },
    input(t) {
      return this._value = t, this.value = t, Promise.resolve();
    },
    isSettled: !0
  };
}
function Ds(e) {
  return "__FKP" in e;
}
function Ls(e) {
  const t = e || {}, r = Vs(t), n = new Proxy(r, {
    get(...s) {
      const [, i] = s;
      if (i === "__FKNode__")
        return !0;
      const a = r.traps.get(i);
      return a && a.get ? a.get(n, r) : Reflect.get(...s);
    },
    set(...s) {
      const [, i, a] = s, l = r.traps.get(i);
      return l && l.set ? l.set(n, r, i, a) : Reflect.set(...s);
    }
  });
  return Ns(n, t);
}
function yt(e) {
  return typeof e != "string" && C(e, "$el");
}
function vt(e) {
  return typeof e != "string" && C(e, "$cmp");
}
function ye(e) {
  return !e || typeof e == "string" ? !1 : C(e, "if") && C(e, "then");
}
function qs(e) {
  return typeof e != "string" && "$formkit" in e;
}
function Ts(e) {
  if (typeof e == "string")
    return {
      $el: "text",
      children: e
    };
  if (qs(e)) {
    const {
      $formkit: t,
      for: r,
      if: n,
      children: s,
      bind: i,
      ...a
    } = e;
    return Object.assign(
      {
        $cmp: "FormKit",
        props: { ...a, type: t }
      },
      n ? { if: n } : {},
      r ? { for: r } : {},
      s ? { children: s } : {},
      i ? { bind: i } : {}
    );
  }
  return e;
}
function Z(e) {
  let t;
  const r = /* @__PURE__ */ new Set(), n = function(m, d) {
    return typeof m == "function" ? m(d) : m;
  }, s = [
    {
      "&&": (c, m, d) => n(c, d) && n(m, d),
      "||": (c, m, d) => n(c, d) || n(m, d)
    },
    {
      "===": (c, m, d) => n(c, d) === n(m, d),
      "!==": (c, m, d) => n(c, d) !== n(m, d),
      "==": (c, m, d) => n(c, d) == n(m, d),
      "!=": (c, m, d) => n(c, d) != n(m, d),
      ">=": (c, m, d) => n(c, d) >= n(m, d),
      "<=": (c, m, d) => n(c, d) <= n(m, d),
      ">": (c, m, d) => n(c, d) > n(m, d),
      "<": (c, m, d) => n(c, d) < n(m, d)
    },
    {
      "+": (c, m, d) => n(c, d) + n(m, d),
      "-": (c, m, d) => n(c, d) - n(m, d)
    },
    {
      "*": (c, m, d) => n(c, d) * n(m, d),
      "/": (c, m, d) => n(c, d) / n(m, d),
      "%": (c, m, d) => n(c, d) % n(m, d)
    }
  ], i = s.reduce((c, m) => c.concat(Object.keys(m)), []), a = new Set(i.map((c) => c.charAt(0)));
  function l(c, m, d, _) {
    const S = c.filter(($) => $.startsWith(m));
    return S.length ? S.find(($) => _.length >= d + $.length && _.substring(d, d + $.length) === $ ? $ : !1) : !1;
  }
  function o(c, m, d = 1) {
    let _ = d ? m.substring(c + 1).trim() : m.substring(0, c).trim();
    if (!_.length)
      return -1;
    if (!d) {
      const $ = _.split("").reverse(), w = $.findIndex((u) => a.has(u));
      _ = $.slice(w).join("");
    }
    const S = _[0];
    return s.findIndex(($) => {
      const w = Object.keys($);
      return !!l(w, S, 0, _);
    });
  }
  function y(c, m) {
    let d = "";
    const _ = m.length;
    let S = 0;
    for (let $ = c; $ < _; $++) {
      const w = m.charAt($);
      if (w === "(")
        S++;
      else if (w === ")")
        S--;
      else if (S === 0 && w === " ")
        continue;
      if (S === 0 && l(i, w, $, m))
        return [d, $ - 1];
      d += w;
    }
    return [d, m.length - 1];
  }
  function v(c, m = 0) {
    const d = s[m], _ = c.length, S = Object.keys(d);
    let $ = 0, w = !1, u = null, p = "", P = null, R, j = "", M = "", f = "", k = "", x = 0;
    const N = (V, F) => {
      V ? f += F : p += F;
    };
    for (let V = 0; V < _; V++)
      if (j = M, M = c.charAt(V), (M === "'" || M === '"') && j !== "\\" && ($ === 0 && !w || $ && !k)) {
        $ ? k = M : w = M, N($, M);
        continue;
      } else if (w && (M !== w || j === "\\") || k && (M !== k || j === "\\")) {
        N($, M);
        continue;
      } else if (w === M) {
        w = !1, N($, M);
        continue;
      } else if (k === M) {
        k = !1, N($, M);
        continue;
      } else {
        if (M === " ")
          continue;
        if (M === "(")
          $ === 0 ? x = V : f += M, $++;
        else if (M === ")")
          if ($--, $ === 0) {
            const F = typeof p == "string" && p.startsWith("$") ? p : void 0, fe = F && c.charAt(V + 1) === ".";
            let J = "";
            fe && ([J, V] = y(V + 2, c));
            const me = u ? m : o(x, c, 0), ce = o(V, c);
            me === -1 && ce === -1 ? (p = g(f, -1, F, J), typeof p == "string" && (p = f)) : u && (me >= ce || ce === -1) && m === me ? (P = u.bind(null, g(f, -1, F, J)), u = null, p = "") : ce > me && m === ce ? p = g(f, -1, F, J) : p += `(${f})${fe ? `.${J}` : ""}`, f = "";
          } else
            f += M;
        else if ($ === 0 && (R = l(S, M, V, c))) {
          V === 0 && W(103, [R, c]), V += R.length - 1, V === c.length - 1 && W(104, [R, c]), u ? p && (P = u.bind(null, g(p, m)), u = d[R].bind(null, P), p = "") : P ? (u = d[R].bind(null, g(P, m)), P = null) : (u = d[R].bind(null, g(p, m)), p = "");
          continue;
        } else
          N($, M);
      }
    return p && u && (u = u.bind(null, g(p, m))), u = !u && P ? P : u, !u && p && (u = (V, F) => typeof V == "function" ? V(F) : V, u = u.bind(null, g(p, m))), !u && !p && W(105, c), u;
  }
  function g(c, m, d, _) {
    if (d) {
      const S = g(d, s.length);
      let $, w = _ ? Z(`$${_}`) : !1;
      if (typeof S == "function") {
        const u = kn(String(c)).map(
          (p) => g(p, -1)
        );
        return (p) => {
          const P = S(p);
          return typeof P != "function" ? (je(150, d), P) : ($ = P(
            ...u.map(
              (R) => typeof R == "function" ? R(p) : R
            )
          ), w && (w = w.provide((R) => {
            const j = t(R);
            return R.reduce(
              (f, k) => {
                if (k === _ || (_ == null ? void 0 : _.startsWith(`${k}(`))) {
                  const N = Sn($, k);
                  f[k] = () => N;
                } else
                  f[k] = j[k];
                return f;
              },
              {}
            );
          })), w ? w() : $);
        };
      }
    } else if (typeof c == "string") {
      if (c === "true")
        return !0;
      if (c === "false")
        return !1;
      if (c === "undefined")
        return;
      if (_n(c))
        return wn(c.substring(1, c.length - 1));
      if (!isNaN(+c))
        return Number(c);
      if (m < s.length - 1)
        return v(c, m + 1);
      if (c.startsWith("$")) {
        const S = c.substring(1);
        return r.add(S), function(w) {
          return S in w ? w[S]() : void 0;
        };
      }
      return c;
    }
    return c;
  }
  const E = v(
    e.startsWith("$:") ? e.substring(2) : e
  ), h = Array.from(r);
  function b(c) {
    return t = c, Object.assign(
      // @ts-ignore - @rollup/plugin-typescript doesn't like this
      E.bind(null, c(h)),
      { provide: b }
    );
  }
  return Object.assign(E, {
    provide: b
  });
}
function ze(e, t, r) {
  return r ? typeof r == "string" ? r.split(" ").reduce(
    (s, i) => Object.assign(s, { [i]: !0 }),
    {}
  ) : typeof r == "function" ? ze(
    e,
    t,
    r(t, e)
  ) : r : {};
}
function zs(e, t, ...r) {
  const n = r.reduce((s, i) => {
    if (!i)
      return st(s);
    const { $reset: a, ...l } = i;
    return st(a ? l : Object.assign(s, l));
  }, {});
  return Object.keys(
    e.hook.classes.dispatch({ property: t, classes: n }).classes
  ).filter((s) => n[s]).join(" ") || null;
}
function st(e) {
  const t = "$remove:";
  let r = !1;
  const n = Object.keys(e).filter((s) => (e[s] && s.startsWith(t) && (r = !0), e[s]));
  return n.length > 1 && r && n.filter((i) => i.startsWith(t)).map((i) => {
    const a = i.substring(t.length);
    e[a] = !1, e[i] = !1;
  }), e;
}
var Be = "1.6.7", Cr = /* @__PURE__ */ new WeakSet();
function rt(e, t) {
  const r = t || Object.assign(/* @__PURE__ */ new Map(), { active: !1 }), n = /* @__PURE__ */ new Map(), s = function(v) {
    var g;
    r.active && (r.has(e) || r.set(e, /* @__PURE__ */ new Set()), (g = r.get(e)) == null || g.add(v));
  }, i = function(v) {
    return new Proxy(v, {
      get(...g) {
        return typeof g[1] == "string" && s(`prop:${g[1]}`), Reflect.get(...g);
      }
    });
  }, a = function(v) {
    return new Proxy(v, {
      get(...g) {
        return g[1] === "value" ? (E) => (s(`count:${E}`), v.value(E)) : Reflect.get(...g);
      }
    });
  }, l = function(v, g) {
    return Ve(v) ? rt(v, r) : (g === "value" && s("commit"), g === "_value" && s("input"), g === "props" ? i(v) : g === "ledger" ? a(v) : (g === "children" && (s("child"), s("childRemoved")), v));
  }, {
    proxy: o,
    revoke: y
  } = Proxy.revocable(e, {
    get(...v) {
      switch (v[1]) {
        case "_node":
          return e;
        case "deps":
          return r;
        case "watch":
          return (E, h, b) => Or(o, E, h, b);
        case "observe":
          return () => {
            const E = new Map(r);
            return r.clear(), r.active = !0, E;
          };
        case "stopObserve":
          return () => {
            const E = new Map(r);
            return r.active = !1, E;
          };
        case "receipts":
          return n;
        case "kill":
          return () => {
            Er(n), Cr.add(v[2]), y();
          };
      }
      const g = Reflect.get(...v);
      return typeof g == "function" ? (...E) => {
        const h = g(...E);
        return l(h, v[1]);
      } : l(g, v[1]);
    }
  });
  return o;
}
function Pr(e, [t, r], n, s) {
  t.forEach((i, a) => {
    i.forEach((l) => {
      e.receipts.has(a) || e.receipts.set(a, {});
      const o = e.receipts.get(a) ?? {};
      o[l] = o[l] ?? [], o[l].push(a.on(l, n, s)), e.receipts.set(a, o);
    });
  }), r.forEach((i, a) => {
    i.forEach((l) => {
      if (e.receipts.has(a)) {
        const o = e.receipts.get(a);
        o && C(o, l) && (o[l].map(a.off), delete o[l], e.receipts.set(a, o));
      }
    });
  });
}
function Er(e) {
  e.forEach((t, r) => {
    for (const n in t)
      t[n].map(r.off);
  }), e.clear();
}
function Or(e, t, r, n) {
  const s = (l) => {
    const o = e.stopObserve();
    Pr(
      e,
      Mr(i, o),
      () => Or(e, t, r, n),
      n
    ), r && r(l);
  }, i = new Map(e.deps);
  e.observe();
  const a = t(e);
  a instanceof Promise ? a.then((l) => s(l)) : s(a);
}
function Mr(e, t) {
  const r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  return t.forEach((s, i) => {
    if (!e.has(i))
      r.set(i, s);
    else {
      const a = /* @__PURE__ */ new Set(), l = e.get(i);
      s.forEach(
        (o) => !(l != null && l.has(o)) && a.add(o)
      ), r.set(i, a);
    }
  }), e.forEach((s, i) => {
    if (!t.has(i))
      n.set(i, s);
    else {
      const a = /* @__PURE__ */ new Set(), l = t.get(i);
      s.forEach(
        (o) => !(l != null && l.has(o)) && a.add(o)
      ), n.set(i, a);
    }
  }), [r, n];
}
function Ot(e) {
  return Cr.has(e);
}
var Ir = function({ value: t }) {
  return ["yes", "on", "1", 1, !0, "true"].includes(t);
};
Ir.skipEmpty = !1;
var Ws = Ir, Ks = function({ value: e }, t = !1) {
  const r = Date.parse(t || /* @__PURE__ */ new Date()), n = Date.parse(String(e));
  return isNaN(n) ? !1 : n > r;
}, Hs = Ks, Us = function({ value: e }, t = !1) {
  const r = Date.parse(t || /* @__PURE__ */ new Date()), n = Date.parse(String(e));
  return isNaN(n) ? !1 : n > r || n === r;
}, Bs = Us, Zs = function(e, t) {
  var s;
  if (!t)
    return !1;
  const r = Date.parse(String(e.value)), n = Date.parse(String((s = e.at(t)) == null ? void 0 : s.value));
  return isNaN(n) ? !0 : isNaN(r) ? !1 : r > n;
}, Ys = Zs, Js = function({ value: e }, t = "default") {
  const r = {
    default: /^\p{L}+$/u,
    latin: /^[a-z]+$/i
  }, n = C(r, t) ? t : "default";
  return r[n].test(String(e));
}, Gs = Js, Qs = function({ value: e }, t = "default") {
  const r = {
    default: /^[\p{L} ]+$/u,
    latin: /^[a-z ]+$/i
  }, n = C(r, t) ? t : "default";
  return r[n].test(String(e));
}, Xs = Qs, ei = function({ value: e }, t = "default") {
  const r = {
    default: /^[0-9\p{L}]+$/u,
    latin: /^[0-9a-z]+$/i
  }, n = C(r, t) ? t : "default";
  return r[n].test(String(e));
}, ti = ei, ri = function({ value: e }, t = !1) {
  const r = Date.parse(t || /* @__PURE__ */ new Date()), n = Date.parse(String(e));
  return isNaN(n) ? !1 : n < r;
}, ni = ri, si = function(e, t) {
  var s;
  if (!t)
    return !1;
  const r = Date.parse(String(e.value)), n = Date.parse(String((s = e.at(t)) == null ? void 0 : s.value));
  return isNaN(n) ? !0 : isNaN(r) ? !1 : r < n;
}, ii = si, ai = function({ value: e }, t = !1) {
  const r = Date.parse(t || /* @__PURE__ */ new Date()), n = Date.parse(String(e));
  return isNaN(n) ? !1 : n < r || n === r;
}, li = ai, oi = function({ value: t }, r, n) {
  if (!isNaN(t) && !isNaN(r) && !isNaN(n)) {
    const s = 1 * t;
    r = Number(r), n = Number(n);
    const [i, a] = r <= n ? [r, n] : [n, r];
    return s >= 1 * i && s <= 1 * a;
  }
  return !1;
}, ui = oi, zt = /(_confirm(?:ed)?)$/, fi = function(t, r, n = "loose") {
  var i;
  r || (r = zt.test(t.name) ? t.name.replace(zt, "") : `${t.name}_confirm`);
  const s = (i = t.at(r)) == null ? void 0 : i.value;
  return n === "strict" ? t.value === s : t.value == s;
}, ci = fi, pi = function({ value: e }, t = "default") {
  const r = {
    default: /\p{L}/u,
    latin: /[a-z]/i
  }, n = C(r, t) ? t : "default";
  return r[n].test(String(e));
}, mi = pi, di = function({ value: e }, t = "default") {
  const r = {
    default: /[\p{L} ]/u,
    latin: /[a-z ]/i
  }, n = C(r, t) ? t : "default";
  return r[n].test(String(e));
}, yi = di, vi = function({ value: e }, t = "default") {
  const r = {
    default: /[0-9\p{L}]/u,
    latin: /[0-9a-z]/i
  }, n = C(r, t) ? t : "default";
  return r[n].test(String(e));
}, hi = vi, gi = function({ value: e }, t = "default") {
  const r = {
    default: /\p{Ll}/u,
    latin: /[a-z]/
  }, n = C(r, t) ? t : "default";
  return r[n].test(String(e));
}, bi = gi, $i = function({ value: t }) {
  return /[0-9]/.test(String(t));
}, _i = $i, wi = function({ value: e }) {
  return /[!-/:-@[-`{-~]/.test(String(e));
}, ki = wi, Si = function({ value: e }, t = "default") {
  const r = {
    default: /\p{Lu}/u,
    latin: /[A-Z]/
  }, n = C(r, t) ? t : "default";
  return r[n].test(String(e));
}, Ai = Si, xi = function({ value: t }, r, n) {
  r = r instanceof Date ? r.getTime() : Date.parse(r), n = n instanceof Date ? n.getTime() : Date.parse(n);
  const s = t instanceof Date ? t.getTime() : Date.parse(String(t));
  if (r && !n)
    n = r, r = Date.now();
  else if (!r || !s)
    return !1;
  return s >= r && s <= n;
}, Ci = xi, Pi = function({ value: t }, r) {
  return r && typeof r == "string" ? $n(r).test(String(t)) : !isNaN(Date.parse(String(t)));
}, Ei = Pi, Oi = function({ value: t }) {
  return /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(String(t));
}, Mi = Oi, Ii = function({ value: t }, ...r) {
  return typeof t == "string" && r.length ? r.some((n) => t.endsWith(n)) : typeof t == "string" && r.length === 0;
}, Ri = Ii, ji = function({ value: t }, ...r) {
  return r.some((n) => typeof n == "object" ? q(n, t) : n == t);
}, Vi = ji, Ni = function({ value: t }, r = 0, n = 1 / 0) {
  r = parseInt(r), n = isNaN(parseInt(n)) ? 1 / 0 : parseInt(n);
  const s = r <= n ? r : n, i = n >= r ? n : r;
  if (typeof t == "string" || Array.isArray(t))
    return t.length >= s && t.length <= i;
  if (t && typeof t == "object") {
    const a = Object.keys(t).length;
    return a >= s && a <= i;
  }
  return !1;
}, Fi = Ni, Di = function({ value: e }, t = "default") {
  const r = {
    default: /^\p{Ll}+$/u,
    allow_non_alpha: /^[0-9\p{Ll}!-/:-@[-`{-~]+$/u,
    allow_numeric: /^[0-9\p{Ll}]+$/u,
    allow_numeric_dashes: /^[0-9\p{Ll}-]+$/u,
    latin: /^[a-z]+$/
  }, n = C(r, t) ? t : "default";
  return r[n].test(String(e));
}, Li = Di, qi = function({ value: t }, ...r) {
  return r.some((n) => (typeof n == "string" && n.substr(0, 1) === "/" && n.substr(-1) === "/" && (n = new RegExp(n.substr(1, n.length - 2))), n instanceof RegExp ? n.test(String(t)) : n === t));
}, Ti = qi, zi = function({ value: t }, r = 10) {
  return Array.isArray(t) ? t.length <= r : Number(t) <= Number(r);
}, Wi = zi, Ki = function({ value: t }, r = 1) {
  return Array.isArray(t) ? t.length >= r : Number(t) >= Number(r);
}, Hi = Ki, Ui = function({ value: t }, ...r) {
  return !r.some((n) => typeof n == "object" ? q(n, t) : n === t);
}, Bi = Ui, Zi = function({ value: t }) {
  return !isNaN(t);
}, Yi = Zi, Rr = function(e, ...t) {
  return B(e.value) ? t.map((n) => {
    var s;
    return (s = e.at(n)) == null ? void 0 : s.value;
  }).some((n) => !B(n)) : !0;
};
Rr.skipEmpty = !1;
var Ji = Rr, jr = function({ value: t }, r = "default") {
  return r === "trim" && typeof t == "string" ? !B(t.trim()) : !B(t);
};
jr.skipEmpty = !1;
var Gi = jr, Qi = function({ value: t }, ...r) {
  return typeof t == "string" && r.length ? r.some((n) => t.startsWith(n)) : typeof t == "string" && r.length === 0;
}, Xi = Qi, ea = function({ value: e }) {
  return /^[!-/:-@[-`{-~]+$/.test(String(e));
}, ta = ea, ra = function({ value: e }, t = "default") {
  const r = {
    default: /^\p{Lu}+$/u,
    latin: /^[A-Z]+$/
  }, n = C(r, t) ? t : "default";
  return r[n].test(String(e));
}, na = ra, sa = function({ value: t }, ...r) {
  try {
    const n = r.length ? r : ["http:", "https:"], s = new URL(String(t));
    return n.includes(s.protocol);
  } catch {
    return !1;
  }
}, ia = sa;
const aa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({ __proto__: null, accepted: Ws, alpha: Gs, alpha_spaces: Xs, alphanumeric: ti, between: ui, confirm: ci, contains_alpha: mi, contains_alpha_spaces: yi, contains_alphanumeric: hi, contains_lowercase: bi, contains_numeric: _i, contains_symbol: ki, contains_uppercase: Ai, date_after: Hs, date_after_node: Ys, date_after_or_equal: Bs, date_before: ni, date_before_node: ii, date_before_or_equal: li, date_between: Ci, date_format: Ei, email: Mi, ends_with: Ri, is: Vi, length: Fi, lowercase: Li, matches: Ti, max: Wi, min: Hi, not: Bi, number: Yi, require_one: Ji, required: Gi, starts_with: Xi, symbol: ta, uppercase: na, url: ia }, Symbol.toStringTag, { value: "Module" }));
var ht = /* @__PURE__ */ K({
  type: "state",
  blocking: !0,
  visible: !1,
  value: !0,
  key: "validating"
});
function la(e = {}) {
  return function(r) {
    let n = H(r.props.validationRules || {}), s = { ...e, ...n };
    const i = { input: xe(), rerun: null, isPassing: !0 };
    let a = H(r.props.validation);
    r.on("prop:validation", ({ payload: o }) => l(o, n)), r.on(
      "prop:validationRules",
      ({ payload: o }) => l(a, o)
    );
    function l(o, y) {
      var v;
      q(Object.keys(n || {}), Object.keys(y || {})) && q(a, o) || (n = H(y), a = H(o), s = { ...e, ...n }, (v = r.props.parsedRules) == null || v.forEach((g) => {
        Vr(g), Er(g.observer.receipts), g.observer.kill();
      }), r.store.filter(() => !1, "validation"), r.props.parsedRules = Kt(o, s, r), i.isPassing = !0, gt(r, r.props.parsedRules, i));
    }
    r.props.parsedRules = Kt(a, s, r), gt(r, r.props.parsedRules, i);
  };
}
function gt(e, t, r) {
  Ot(e) || (r.input = xe(), e.store.set(
    /* @__PURE__ */ K({
      key: "failing",
      value: !r.isPassing,
      visible: !1
    })
  ), r.isPassing = !0, e.store.filter((n) => !n.meta.removeImmediately, "validation"), t.forEach(
    (n) => n.debounce && clearTimeout(n.timer)
  ), t.length && (e.store.set(ht), bt(0, t, r, !1, () => {
    e.store.remove(ht.key), e.store.set(
      /* @__PURE__ */ K({
        key: "failing",
        value: !r.isPassing,
        visible: !1
      })
    );
  })));
}
function bt(e, t, r, n, s) {
  const i = t[e];
  if (!i)
    return s();
  const a = i.observer;
  if (Ot(a))
    return;
  const l = r.input;
  i.state = null;
  function o(y, v) {
    if (r.input !== l)
      return;
    r.isPassing = r.isPassing && !!v, i.queued = !1;
    const g = a.stopObserve(), E = Mr(i.deps, g);
    if (Pr(
      a,
      E,
      function() {
        try {
          a.store.set(ht);
        } catch {
        }
        i.queued = !0, r.rerun && clearTimeout(r.rerun), r.rerun = setTimeout(
          gt,
          0,
          a,
          t,
          r
        );
      },
      "unshift"
      // We want these listeners to run before other events are emitted so the 'state.validating' will be reliable.
    ), i.deps = g, i.state = v, v === !1 ? ua(i, n || y) : Vr(i), t.length > e + 1) {
      const h = t[e + 1];
      (v || h.force || !h.skipEmpty) && h.state === null && (h.queued = !0), bt(e + 1, t, r, n || y, s);
    } else
      s();
  }
  (!B(a.value) || !i.skipEmpty) && (r.isPassing || i.force) ? i.queued ? oa(i, a, (y) => {
    y instanceof Promise ? y.then((v) => o(!0, v)) : o(!1, y);
  }) : bt(e + 1, t, r, n, s) : B(a.value) && i.skipEmpty && r.isPassing ? (a.observe(), a.value, o(!1, r.isPassing)) : o(!1, null);
}
function oa(e, t, r) {
  e.debounce ? e.timer = setTimeout(() => {
    t.observe(), r(e.rule(t, ...e.args));
  }, e.debounce) : (t.observe(), r(e.rule(t, ...e.args)));
}
function Vr(e) {
  const t = `rule_${e.name}`;
  e.messageObserver && (e.messageObserver = e.messageObserver.kill()), C(e.observer.store, t) && e.observer.store.remove(t);
}
function ua(e, t) {
  const r = e.observer;
  Ot(r) || (e.messageObserver || (e.messageObserver = rt(r._node)), e.messageObserver.watch(
    (n) => ca(
      n,
      e
    ),
    (n) => {
      const s = fa(r, e, n), i = /* @__PURE__ */ K({
        blocking: e.blocking,
        key: `rule_${e.name}`,
        meta: {
          /**
           * Use this key instead of the message root key to produce i18n validation
           * messages.
           */
          messageKey: e.name,
          /**
           * For messages that were created *by or after* a debounced or async
           * validation rule — we make note of it so we can immediately remove them
           * as soon as the next commit happens.
           */
          removeImmediately: t,
          /**
           * Determines if this message should be passed to localization.
           */
          localize: !s,
          /**
           * The arguments that will be passed to the validation rules
           */
          i18nArgs: n
        },
        type: "validation",
        value: s || "This field is not valid."
      });
      r.store.set(i);
    }
  ));
}
function fa(e, t, r) {
  const n = e.props.validationMessages && C(e.props.validationMessages, t.name) ? e.props.validationMessages[t.name] : void 0;
  return typeof n == "function" ? n(...r) : n;
}
function ca(e, t) {
  return [
    {
      node: e,
      name: Nr(e),
      args: t.args
    }
  ];
}
function Nr(e) {
  return typeof e.props.validationLabel == "function" ? e.props.validationLabel(e) : e.props.validationLabel || e.props.label || e.props.name || String(e.name);
}
var Fr = "(?:[\\*+?()0-9]+)", Dr = "[a-zA-Z][a-zA-Z0-9_]+", pa = new RegExp(
  `^(${Fr}?${Dr})(?:\\:(.*)+)?$`,
  "i"
), ma = new RegExp(`^(${Fr})(${Dr})$`, "i"), da = /([\*+?]+)?(\(\d+\))([\*+?]+)?/, Wt = /\(\d+\)/, ya = {
  blocking: !0,
  debounce: 0,
  force: !1,
  skipEmpty: !0,
  name: ""
};
function Kt(e, t, r) {
  return e ? (typeof e == "string" ? va(e) : ke(e)).reduce((s, i) => {
    let a = i.shift();
    const l = {};
    if (typeof a == "string") {
      const [o, y] = ga(a);
      C(t, o) && (a = t[o], Object.assign(l, y));
    }
    return typeof a == "function" && s.push({
      observer: rt(r),
      rule: a,
      args: i,
      timer: 0,
      state: null,
      queued: !0,
      deps: /* @__PURE__ */ new Map(),
      ...ya,
      ...ba(l, a)
    }), s;
  }, []) : [];
}
function va(e) {
  return e.split("|").reduce((t, r) => {
    const n = ha(r);
    return n && t.push(n), t;
  }, []);
}
function ha(e) {
  const t = e.trim();
  if (t) {
    const r = t.match(pa);
    if (r && typeof r[1] == "string") {
      const n = r[1].trim(), s = r[2] && typeof r[2] == "string" ? r[2].split(",").map((i) => i.trim()) : [];
      return [n, ...s];
    }
  }
  return !1;
}
function ga(e) {
  const t = e.match(ma);
  if (!t)
    return [e, { name: e }];
  const r = {
    "*": { force: !0 },
    "+": { skipEmpty: !1 },
    "?": { blocking: !1 }
  }, [, n, s] = t, i = Wt.test(n) ? n.match(da) || [] : [, n];
  return [
    s,
    [i[1], i[2], i[3]].reduce(
      (a, l) => (l && (Wt.test(l) ? a.debounce = parseInt(l.substr(1, l.length - 1)) : l.split("").forEach(
        (o) => C(r, o) && Object.assign(a, r[o])
      )), a),
      { name: s }
    )
  ];
}
function ba(e, t) {
  return e.name || (e.name = t.ruleName || t.name), ["skipEmpty", "force", "debounce", "blocking"].reduce(
    (r, n) => (C(t, n) && !C(r, n) && Object.assign(r, {
      [n]: t[n]
    }), r),
    e
  );
}
function O(e) {
  return e[0].toUpperCase() + e.substr(1);
}
function Ht(e, t = "or") {
  return e.reduce((r, n, s) => (r += n, s <= e.length - 2 && e.length > 2 && (r += ", "), s === e.length - 2 && (r += `${e.length === 2 ? " " : ""}${t} `), r), "");
}
function Le(e) {
  const t = typeof e == "string" ? new Date(Date.parse(e)) : e;
  return t instanceof Date ? new Intl.DateTimeFormat(void 0, {
    dateStyle: "medium",
    timeZone: "UTC"
  }).format(t) : "(unknown)";
}
function $a(e, t) {
  return Number(e) >= Number(t) ? [t, e] : [e, t];
}
var _a = {
  /**
   * Shown on a button for adding additional items.
   */
  add: "Add",
  /**
   * Shown when a button to remove items is visible.
   */
  remove: "Remove",
  /**
   * Shown when there are multiple items to remove at the same time.
   */
  removeAll: "Remove all",
  /**
   * Shown when all fields are not filled out correctly.
   */
  incomplete: "Sorry, not all fields are filled out correctly.",
  /**
   * Shown in a button inside a form to submit the form.
   */
  submit: "Submit",
  /**
   * Shown when no files are selected.
   */
  noFiles: "No file chosen",
  /**
   * Shown on buttons that move fields up in a list.
   */
  moveUp: "Move up",
  /**
   * Shown on buttons that move fields down in a list.
   */
  moveDown: "Move down",
  /**
   * Shown when something is actively loading.
   */
  isLoading: "Loading...",
  /**
   * Shown when there is more to load.
   */
  loadMore: "Load more",
  /**
   * Show on buttons that navigate state forward
   */
  next: "Next",
  /**
   * Show on buttons that navigate state backward
   */
  prev: "Previous",
  /**
   * Shown when adding all values.
   */
  addAllValues: "Add all values",
  /**
   * Shown when adding selected values.
   */
  addSelectedValues: "Add selected values",
  /**
   * Shown when removing all values.
   */
  removeAllValues: "Remove all values",
  /**
   * Shown when removing selected values.
   */
  removeSelectedValues: "Remove selected values",
  /**
   * Shown when there is a date to choose.
   */
  chooseDate: "Choose date",
  /**
   * Shown when there is a date to change.
   */
  changeDate: "Change date",
  /**
   * Shown above error summaries when someone attempts to submit a form with
   * errors and the developer has implemented `<FormKitSummary />`.
   */
  summaryHeader: "There were errors in your form.",
  /*
   * Shown when there is something to close
   */
  close: "Close",
  /**
   * Shown when there is something to open.
   */
  open: "Open"
}, wa = {
  /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */
  accepted({ name: e }) {
    return `Please accept the ${e}.`;
  },
  /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */
  date_after({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${O(e)} must be after ${Le(t[0])}.` : `${O(e)} must be in the future.`;
  },
  /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */
  alpha({ name: e }) {
    return `${O(e)} can only contain alphabetical characters.`;
  },
  /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */
  alphanumeric({ name: e }) {
    return `${O(e)} can only contain letters and numbers.`;
  },
  /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */
  alpha_spaces({ name: e }) {
    return `${O(e)} can only contain letters and spaces.`;
  },
  /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */
  contains_alpha({ name: e }) {
    return `${O(e)} must contain alphabetical characters.`;
  },
  /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */
  contains_alphanumeric({ name: e }) {
    return `${O(e)} must contain letters or numbers.`;
  },
  /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */
  contains_alpha_spaces({ name: e }) {
    return `${O(e)} must contain letters or spaces.`;
  },
  /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */
  contains_symbol({ name: e }) {
    return `${O(e)} must contain a symbol.`;
  },
  /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */
  contains_uppercase({ name: e }) {
    return `${O(e)} must contain an uppercase letter.`;
  },
  /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */
  contains_lowercase({ name: e }) {
    return `${O(e)} must contain a lowercase letter.`;
  },
  /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */
  contains_numeric({ name: e }) {
    return `${O(e)} must contain numbers.`;
  },
  /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */
  symbol({ name: e }) {
    return `${O(e)} must be a symbol.`;
  },
  /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */
  uppercase({ name: e }) {
    return `${O(e)} can only contain uppercase letters.`;
  },
  /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */
  lowercase({ name: e, args: t }) {
    let r = "";
    return Array.isArray(t) && t.length && (t[0] === "allow_non_alpha" && (r = ", numbers and symbols"), t[0] === "allow_numeric" && (r = " and numbers"), t[0] === "allow_numeric_dashes" && (r = ", numbers and dashes")), `${O(e)} can only contain lowercase letters${r}.`;
  },
  /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */
  date_before({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${O(e)} must be before ${Le(t[0])}.` : `${O(e)} must be in the past.`;
  },
  /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */
  between({ name: e, args: t }) {
    if (isNaN(t[0]) || isNaN(t[1]))
      return "This field was configured incorrectly and can’t be submitted.";
    const [r, n] = $a(t[0], t[1]);
    return `${O(e)} must be between ${r} and ${n}.`;
  },
  /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */
  confirm({ name: e }) {
    return `${O(e)} does not match.`;
  },
  /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */
  date_format({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${O(e)} is not a valid date, please use the format ${t[0]}` : "This field was configured incorrectly and can’t be submitted";
  },
  /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */
  date_between({ name: e, args: t }) {
    return `${O(e)} must be between ${Le(t[0])} and ${Le(t[1])}`;
  },
  /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */
  email: "Please enter a valid email address.",
  /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */
  ends_with({ name: e, args: t }) {
    return `${O(e)} doesn’t end with ${Ht(t)}.`;
  },
  /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */
  is({ name: e }) {
    return `${O(e)} is not an allowed value.`;
  },
  /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */
  length({ name: e, args: [t = 0, r = 1 / 0] }) {
    const n = Number(t) <= Number(r) ? t : r, s = Number(r) >= Number(t) ? r : t;
    return n == 1 && s === 1 / 0 ? `${O(e)} must be at least one character.` : n == 0 && s ? `${O(e)} must be less than or equal to ${s} characters.` : n === s ? `${O(e)} should be ${s} characters long.` : n && s === 1 / 0 ? `${O(e)} must be greater than or equal to ${n} characters.` : `${O(e)} must be between ${n} and ${s} characters.`;
  },
  /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */
  matches({ name: e }) {
    return `${O(e)} is not an allowed value.`;
  },
  /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */
  max({ name: e, node: { value: t }, args: r }) {
    return Array.isArray(t) ? `Cannot have more than ${r[0]} ${e}.` : `${O(e)} must be no more than ${r[0]}.`;
  },
  /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */
  mime({ name: e, args: t }) {
    return t[0] ? `${O(e)} must be of the type: ${t[0]}` : "No file formats allowed.";
  },
  /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */
  min({ name: e, node: { value: t }, args: r }) {
    return Array.isArray(t) ? `Cannot have fewer than ${r[0]} ${e}.` : `${O(e)} must be at least ${r[0]}.`;
  },
  /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */
  not({ name: e, node: { value: t } }) {
    return `“${t}” is not an allowed ${e}.`;
  },
  /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */
  number({ name: e }) {
    return `${O(e)} must be a number.`;
  },
  /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */
  require_one: ({ name: e, node: t, args: r }) => {
    const n = r.map((s) => {
      const i = t.at(s);
      return i ? Nr(i) : !1;
    }).filter((s) => !!s);
    return n.unshift(e), `${n.join(" or ")} is required.`;
  },
  /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */
  required({ name: e }) {
    return `${O(e)} is required.`;
  },
  /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */
  starts_with({ name: e, args: t }) {
    return `${O(e)} doesn’t start with ${Ht(t)}.`;
  },
  /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */
  url() {
    return "Please enter a valid URL.";
  },
  /**
   * Shown when the date is invalid.
   */
  invalidDate: "The selected date is invalid."
}, ka = { ui: _a, validation: wa }, Ut = /* @__PURE__ */ new Set();
function Sa(e) {
  return function(r) {
    Ut.add(r), r.on("destroying", () => Ut.delete(r));
    let n = Bt(r.config.locale, e), s = n ? e[n] : {};
    r.on("prop:locale", ({ payload: i }) => {
      n = Bt(i, e), s = n ? e[n] : {}, r.store.touch();
    }), r.on("prop:label", () => r.store.touch()), r.on("prop:validationLabel", () => r.store.touch()), r.hook.text((i, a) => {
      var o, y;
      const l = ((o = i.meta) == null ? void 0 : o.messageKey) || i.key;
      if (C(s, i.type) && C(s[i.type], l)) {
        const v = s[i.type][l];
        typeof v == "function" ? i.value = Array.isArray((y = i.meta) == null ? void 0 : y.i18nArgs) ? v(...i.meta.i18nArgs) : v(i) : i.value = v;
      }
      return a(i);
    });
  };
}
function Bt(e, t) {
  if (C(t, e))
    return e;
  const [r] = e.split("-");
  if (C(t, r))
    return r;
  for (const n in t)
    return n;
  return !1;
}
function Aa(...e) {
  const t = e.reduce(
    (n, s) => ae(n, s),
    {}
  ), r = () => {
  };
  return r.library = function(n) {
    const s = ge(n.props.type);
    C(t, s) && n.define(t[s]);
  }, r;
}
var xa = [
  "classes",
  "config",
  "delay",
  "errors",
  "id",
  "index",
  "inputErrors",
  "library",
  "modelValue",
  "onUpdate:modelValue",
  "name",
  "number",
  "parent",
  "plugins",
  "sectionsSchema",
  "type",
  "validation",
  "validationLabel",
  "validationMessages",
  "validationRules",
  // Runtime event props:
  "onInput",
  "onInputRaw",
  "onUpdate:modelValue",
  "onNode",
  "onSubmit",
  "onSubmitInvalid",
  "onSubmitRaw"
];
function nt(e) {
  return e && typeof e == "object" && "group" in e && Array.isArray(e.options);
}
function Lr(e, t = { count: 1 }) {
  return Array.isArray(e) ? e.map(
    (r) => {
      if (typeof r == "string" || typeof r == "number")
        return {
          label: String(r),
          value: String(r)
        };
      if (typeof r == "object") {
        if ("group" in r)
          return r.options = Lr(r.options || [], t), r;
        "value" in r && typeof r.value != "string" && Object.assign(r, {
          value: `__mask_${t.count++}`,
          __original: r.value
        });
      }
      return r;
    }
  ) : Object.keys(e).map((r) => ({
    label: e[r],
    value: r
  }));
}
function pe(e, t, r = !1) {
  if (Array.isArray(e)) {
    for (const n of e)
      if (!(typeof n != "object" && n)) {
        if (nt(n)) {
          const s = pe(n.options, t, !0);
          if (s !== void 0)
            return s;
        } else if (t == n.value)
          return "__original" in n ? n.__original : n.value;
      }
  }
  return r ? void 0 : t;
}
function Ae(e, t) {
  return e === null && t === void 0 || e === void 0 && t === null ? !1 : e == t ? !0 : we(e) && we(t) ? q(e, t) : !1;
}
function Mt(e) {
  e.hook.prop((t, r) => {
    var n;
    return t.prop === "options" && (typeof t.value == "function" ? (e.props.optionsLoader = t.value, t.value = []) : ((n = e.props)._normalizeCounter ?? (n._normalizeCounter = { count: 1 }), t.value = Lr(t.value, e.props._normalizeCounter))), r(t);
  });
}
// @__NO_SIDE_EFFECTS__
function A(e, t, r = !1) {
  return (...n) => {
    const s = (i) => {
      const a = !t || typeof t == "string" ? { $el: t } : t();
      return (yt(a) || vt(a)) && (a.meta ? a.meta.section = e : a.meta = { section: e }, n.length && !a.children && (a.children = [
        ...n.map(
          (l) => typeof l == "function" ? l(i) : l
        )
      ]), yt(a) && (a.attrs = {
        class: `$classes.${e}`,
        ...a.attrs || {}
      })), {
        if: `$slots.${e}`,
        then: `$slots.${e}`,
        else: e in i ? /* @__PURE__ */ Oe(a, i[e]) : a
      };
    };
    return s._s = e, r ? /* @__PURE__ */ Ca(s) : s;
  };
}
// @__NO_SIDE_EFFECTS__
function Ca(e) {
  return (t) => [e(t)];
}
function Ze(e) {
  return !!(e && typeof e == "object" && ("$el" in e || "$cmp" in e || "$formkit" in e));
}
// @__NO_SIDE_EFFECTS__
function Oe(e, t = {}) {
  return typeof e == "string" ? Ze(t) || typeof t == "string" ? t : e : Array.isArray(e) ? Ze(t) ? t : e : ae(e, t);
}
var Pa = /* @__PURE__ */ A("actions", () => ({
  $el: "div",
  if: "$actions"
})), Ye = /* @__PURE__ */ A("input", () => ({
  $el: "input",
  bind: "$attrs",
  attrs: {
    type: "$type",
    name: "$node.props.altName || $node.name",
    disabled: "$option.attrs.disabled || $disabled",
    onInput: "$handlers.toggleChecked",
    checked: "$fns.eq($_value, $onValue)",
    onBlur: "$handlers.blur",
    value: "$: true",
    id: "$id",
    "aria-describedby": {
      if: "$options.length",
      then: {
        if: "$option.help",
        then: '$: "help-" + $option.attrs.id',
        else: void 0
      },
      else: {
        if: "$help",
        then: '$: "help-" + $id',
        else: void 0
      }
    }
  }
})), qr = /* @__PURE__ */ A("optionHelp", () => ({
  $el: "div",
  if: "$option.help",
  attrs: {
    id: '$: "help-" + $option.attrs.id'
  }
})), Je = /* @__PURE__ */ A("inner", "span"), Ge = /* @__PURE__ */ A("label", "span"), Tr = /* @__PURE__ */ A("option", () => ({
  $el: "li",
  for: ["option", "$options"],
  attrs: {
    "data-disabled": "$option.attrs.disabled || $disabled || undefined"
  }
})), zr = /* @__PURE__ */ A("options", "ul"), Qe = /* @__PURE__ */ A("wrapper", () => ({
  $el: "label",
  attrs: {
    "data-disabled": {
      if: "$options.length",
      then: void 0,
      else: "$disabled || undefined"
    },
    "data-checked": {
      if: "$options == undefined",
      then: "$fns.eq($_value, $onValue) || undefined",
      else: "$fns.isChecked($option.value) || undefined"
    }
  }
})), Ea = /* @__PURE__ */ A("input", () => ({
  $el: "button",
  bind: "$attrs",
  attrs: {
    type: "$type",
    disabled: "$disabled",
    name: "$node.name",
    id: "$id"
  }
})), Oa = /* @__PURE__ */ A("default", null), Xe = /* @__PURE__ */ A("decorator", () => ({
  $el: "span",
  attrs: {
    "aria-hidden": "true"
  }
})), Wr = /* @__PURE__ */ A("fieldset", () => ({
  $el: "fieldset",
  attrs: {
    id: "$id",
    "aria-describedby": {
      if: "$help",
      then: '$: "help-" + $id',
      else: void 0
    }
  }
})), Ma = /* @__PURE__ */ A("input", () => ({
  $el: "input",
  bind: "$attrs",
  attrs: {
    type: "file",
    disabled: "$disabled",
    name: "$node.name",
    onChange: "$handlers.files",
    onBlur: "$handlers.blur",
    id: "$id",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  }
})), Ia = /* @__PURE__ */ A("fileItem", () => ({
  $el: "li",
  for: ["file", "$value"]
})), Ra = /* @__PURE__ */ A("fileList", () => ({
  $el: "ul",
  if: "$value.length",
  attrs: {
    "data-has-multiple": "$_hasMultipleFiles"
  }
})), ja = /* @__PURE__ */ A("fileName", () => ({
  $el: "span",
  attrs: {
    class: "$classes.fileName"
  }
})), Zt = /* @__PURE__ */ A("fileRemove", () => ({
  $el: "button",
  attrs: {
    type: "button",
    onClick: "$handlers.resetFiles"
  }
})), Va = /* @__PURE__ */ A("form", () => ({
  $el: "form",
  bind: "$attrs",
  meta: {
    autoAnimate: !0
  },
  attrs: {
    id: "$id",
    name: "$node.name",
    onSubmit: "$handlers.submit",
    "data-loading": "$state.loading || undefined"
  }
})), It = /* @__PURE__ */ A("wrapper", null, !0), Q = /* @__PURE__ */ A("help", () => ({
  $el: "div",
  if: "$help",
  attrs: {
    id: '$: "help-" + $id'
  }
})), D = (e, t) => (/* @__PURE__ */ A(`${e}Icon`, () => {
  const r = `_raw${e.charAt(0).toUpperCase()}${e.slice(1)}Icon`;
  return {
    if: `$${e}Icon && $${r}`,
    $el: `${t || "span"}`,
    attrs: {
      class: `$classes.${e}Icon + " " + $classes.icon`,
      innerHTML: `$${r}`,
      onClick: `$handlers.iconClick(${e})`,
      role: `$fns.iconRole(${e})`,
      tabindex: `$fns.iconRole(${e}) === "button" && "0" || undefined`,
      for: {
        if: `${t === "label"}`,
        then: "$id"
      }
    }
  };
}))(), Ne = /* @__PURE__ */ A("inner", "div"), Fe = /* @__PURE__ */ A("label", () => ({
  $el: "label",
  if: "$label",
  attrs: {
    for: "$id"
  }
})), Kr = /* @__PURE__ */ A("legend", () => ({
  $el: "legend",
  if: "$label"
})), le = /* @__PURE__ */ A("message", () => ({
  $el: "li",
  for: ["message", "$messages"],
  attrs: {
    key: "$message.key",
    id: "$id + '-' + $message.key",
    "data-message-type": "$message.type"
  }
})), oe = /* @__PURE__ */ A("messages", () => ({
  $el: "ul",
  if: "$defaultMessagePlacement && $fns.length($messages)"
})), Na = /* @__PURE__ */ A("noFiles", () => ({
  $el: "span",
  if: "$value == null || $value.length == 0"
})), Fa = /* @__PURE__ */ A("optGroup", () => ({
  $el: "optgroup",
  bind: "$option.attrs",
  attrs: {
    label: "$option.group"
  }
})), Yt = /* @__PURE__ */ A("option", () => ({
  $el: "option",
  bind: "$option.attrs",
  attrs: {
    class: "$classes.option",
    value: "$option.value",
    selected: "$fns.isSelected($option)"
  }
})), Jt = /* @__PURE__ */ A("options", () => ({
  $el: null,
  if: "$options.length",
  for: ["option", "$option.options || $options"]
})), ue = /* @__PURE__ */ A("outer", () => ({
  $el: "div",
  meta: {
    autoAnimate: !0
  },
  attrs: {
    key: "$id",
    "data-family": "$family || undefined",
    "data-type": "$type",
    "data-multiple": '$attrs.multiple || ($type != "select" && $options != undefined) || undefined',
    "data-has-multiple": "$_hasMultipleFiles",
    "data-disabled": '$: ($disabled !== "false" && $disabled) || undefined',
    "data-empty": "$state.empty || undefined",
    "data-complete": "$state.complete || undefined",
    "data-invalid": "$state.invalid || undefined",
    "data-errors": "$state.errors || undefined",
    "data-submitted": "$state.submitted || undefined",
    "data-prefix-icon": "$_rawPrefixIcon !== undefined || undefined",
    "data-suffix-icon": "$_rawSuffixIcon !== undefined || undefined",
    "data-prefix-icon-click": "$onPrefixIconClick !== undefined || undefined",
    "data-suffix-icon-click": "$onSuffixIconClick !== undefined || undefined"
  }
})), X = /* @__PURE__ */ A("prefix", null), Da = /* @__PURE__ */ A("input", () => ({
  $el: "select",
  bind: "$attrs",
  attrs: {
    id: "$id",
    "data-placeholder": "$fns.showPlaceholder($_value, $placeholder)",
    disabled: "$disabled",
    class: "$classes.input",
    name: "$node.name",
    onChange: "$handlers.onChange",
    onInput: "$handlers.selectInput",
    onBlur: "$handlers.blur",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  }
})), La = /* @__PURE__ */ A("submit", () => ({
  $cmp: "FormKit",
  bind: "$submitAttrs",
  props: {
    type: "submit",
    label: "$submitLabel"
  }
})), ee = /* @__PURE__ */ A("suffix", null), Hr = /* @__PURE__ */ A("input", () => ({
  $el: "input",
  bind: "$attrs",
  attrs: {
    type: "$type",
    disabled: "$disabled",
    name: "$node.name",
    onInput: "$handlers.DOMInput",
    onBlur: "$handlers.blur",
    value: "$_value",
    id: "$id",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  }
})), qa = /* @__PURE__ */ A("input", () => ({
  $el: "textarea",
  bind: "$attrs",
  attrs: {
    disabled: "$disabled",
    name: "$node.name",
    onInput: "$handlers.DOMInput",
    onBlur: "$handlers.blur",
    value: "$_value",
    id: "$id",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  },
  children: "$initialValue"
})), Ce = /* @__PURE__ */ A("wrapper", "div"), Ta = 0;
function Ur(e) {
  (e.type === "group" || e.type === "list") && e.plugins.add(za);
}
function za(e) {
  e.props.type === "radio" && (e.addProps(["altName"]), e.props.altName = `${e.name}_${Ta++}`);
}
function Br(e) {
  return function(t, r) {
    return t.prop === "options" && Array.isArray(t.value) && (t.value = t.value.map((n) => {
      var s;
      return (s = n.attrs) != null && s.id ? n : ae(n, {
        attrs: {
          id: `${e.props.id}-option-${kt(String(n.value))}`
        }
      });
    }), e.props.type === "checkbox" && !Array.isArray(e.value) && (e.isCreated ? e.input([], !1) : e.on("created", () => {
      Array.isArray(e.value) || e.input([], !1);
    }))), r(t);
  };
}
function Wa(e, t) {
  const r = t.target;
  if (r instanceof HTMLInputElement) {
    const n = Array.isArray(e.props.options) ? pe(e.props.options, r.value) : r.value;
    Array.isArray(e.props.options) && e.props.options.length ? Array.isArray(e._value) ? e._value.some((s) => Ae(n, s)) ? e.input(
      e._value.filter(
        (s) => !Ae(n, s)
      )
    ) : e.input([...e._value, n]) : e.input([n]) : r.checked ? e.input(e.props.onValue) : e.input(e.props.offValue);
  }
}
function Ka(e, t) {
  var r, n;
  return (r = e.context) == null || r.value, (n = e.context) == null || n._value, Array.isArray(e._value) ? e._value.some(
    (s) => Ae(pe(e.props.options, t), s)
  ) : !1;
}
function Ha(e) {
  e.on("created", () => {
    var t, r;
    (t = e.context) != null && t.handlers && (e.context.handlers.toggleChecked = Wa.bind(null, e)), (r = e.context) != null && r.fns && (e.context.fns.isChecked = Ka.bind(null, e)), C(e.props, "onValue") || (e.props.onValue = !0), C(e.props, "offValue") || (e.props.offValue = !1);
  }), e.hook.prop(Br(e));
}
function be(e, t) {
  return (r) => {
    r.props[`${e}Icon`] === void 0 && (r.props[`${e}Icon`] = t.startsWith("<svg") ? t : `default:${t}`);
  };
}
function Rt(e) {
  e.on("created", () => {
    "disabled" in e.props && (e.props.disabled = U(e.props.disabled), e.config.disabled = U(e.props.disabled));
  }), e.hook.prop(({ prop: t, value: r }, n) => (r = t === "disabled" ? U(r) : r, n({ prop: t, value: r }))), e.on("prop:disabled", ({ payload: t }) => {
    e.config.disabled = U(t);
  });
}
function We(e, t) {
  return (r) => {
    r.store.set(
      /* @__PURE__ */ K({
        key: e,
        type: "ui",
        value: t || e,
        meta: {
          localize: !0,
          i18nArgs: [r]
        }
      })
    );
  };
}
var it = typeof window < "u";
function Zr(e) {
  e.target instanceof HTMLElement && e.target.hasAttribute("data-file-hover") && e.target.removeAttribute("data-file-hover");
}
function Gt(e, t) {
  t.target instanceof HTMLInputElement ? e === "dragover" && t.target.setAttribute("data-file-hover", "true") : t.preventDefault(), e === "drop" && Zr(t);
}
function Ua(e) {
  We("noFiles", "Select file")(e), We("removeAll", "Remove all")(e), We("remove")(e), e.addProps(["_hasMultipleFiles"]), it && (window._FormKit_File_Drop || (window.addEventListener(
    "dragover",
    Gt.bind(null, "dragover")
  ), window.addEventListener("drop", Gt.bind(null, "drop")), window.addEventListener("dragleave", Zr), window._FormKit_File_Drop = !0)), e.hook.input((t, r) => r(Array.isArray(t) ? t : [])), e.on("input", ({ payload: t }) => {
    e.props._hasMultipleFiles = Array.isArray(t) && t.length > 1 ? !0 : void 0;
  }), e.on("reset", () => {
    if (e.props.id && it) {
      const t = document.getElementById(e.props.id);
      t && (t.value = "");
    }
  }), e.on("created", () => {
    Array.isArray(e.value) || e.input([], !1), e.context && (e.context.handlers.resetFiles = (t) => {
      if (t.preventDefault(), e.input([]), e.props.id && it) {
        const r = document.getElementById(e.props.id);
        r && (r.value = ""), r == null || r.focus();
      }
    }, e.context.handlers.files = (t) => {
      var n, s;
      const r = [];
      if (t.target instanceof HTMLInputElement && t.target.files) {
        for (let i = 0; i < t.target.files.length; i++) {
          let a;
          (a = t.target.files.item(i)) && r.push({ name: a.name, file: a });
        }
        e.input(r);
      }
      e.context && (e.context.files = r), typeof ((n = e.props.attrs) == null ? void 0 : n.onChange) == "function" && ((s = e.props.attrs) == null || s.onChange(t));
    });
  });
}
var Qt = /* @__PURE__ */ K({
  key: "loading",
  value: !0,
  visible: !1
});
async function Ba(e, t) {
  const r = Math.random();
  if (e.props._submitNonce = r, t.preventDefault(), await e.settled, e.ledger.value("validating") && (e.store.set(Qt), await e.ledger.settled("validating"), e.store.remove("loading"), e.props._submitNonce !== r))
    return;
  const n = (s) => s.store.set(
    /* @__PURE__ */ K({
      key: "submitted",
      value: !0,
      visible: !1
    })
  );
  if (e.walk(n), n(e), e.emit("submit-raw"), typeof e.props.onSubmitRaw == "function" && e.props.onSubmitRaw(t, e), e.ledger.value("blocking"))
    typeof e.props.onSubmitInvalid == "function" && e.props.onSubmitInvalid(e), e.props.incompleteMessage !== !1 && Yr(e);
  else if (typeof e.props.onSubmit == "function") {
    const s = e.props.onSubmit(
      e.hook.submit.dispatch(ke(e.value)),
      e
    );
    if (s instanceof Promise) {
      const i = e.props.disabled === void 0 && e.props.submitBehavior !== "live";
      i && (e.props.disabled = !0), e.store.set(Qt), await s, i && (e.props.disabled = !1), e.store.remove("loading");
    }
  } else
    t.target instanceof HTMLFormElement && t.target.submit();
}
function Yr(e) {
  e.store.set(
    /* @__PURE__ */ K({
      blocking: !1,
      key: "incomplete",
      meta: {
        localize: e.props.incompleteMessage === void 0,
        i18nArgs: [{ node: e }],
        showAsMessage: !0
      },
      type: "ui",
      value: e.props.incompleteMessage || "Form incomplete."
    })
  );
}
function Za(e) {
  var t;
  e.props.isForm = !0, e.ledger.count("validating", (r) => r.key === "validating"), (t = e.props).submitAttrs ?? (t.submitAttrs = {
    disabled: e.props.disabled
  }), e.on("prop:disabled", ({ payload: r }) => {
    e.props.submitAttrs = { ...e.props.submitAttrs, disabled: r };
  }), e.on("created", () => {
    var r;
    (r = e.context) != null && r.handlers && (e.context.handlers.submit = Ba.bind(null, e)), C(e.props, "actions") || (e.props.actions = !0);
  }), e.on("prop:incompleteMessage", () => {
    e.store.incomplete && Yr(e);
  }), e.on("settled:blocking", () => e.store.remove("incomplete"));
}
function Ya(e) {
  e.props.ignore === void 0 && (e.props.ignore = !0, e.parent = null);
}
function Ja(e) {
  e.on("created", () => {
    e.context && (e.context.initialValue = e.value || "");
  });
}
function Jr(e) {
  if (typeof e.props.number > "u")
    return;
  const t = ["number", "range", "hidden"].includes(e.props.type);
  e.hook.input((r, n) => {
    if (r === "")
      return n(void 0);
    const s = e.props.number === "integer" ? parseInt(r) : parseFloat(r);
    return Number.isFinite(s) ? n(s) : n(t ? void 0 : r);
  });
}
function Ga(e, t) {
  t.target instanceof HTMLInputElement && e.input(pe(e.props.options, t.target.value));
}
function Qa(e, t) {
  var r, n;
  return (r = e.context) == null || r.value, (n = e.context) == null || n._value, Ae(pe(e.props.options, t), e._value);
}
function Xa(e) {
  e.on("created", () => {
    var t, r;
    Array.isArray(e.props.options) || je(350, {
      node: e,
      inputType: "radio"
    }), (t = e.context) != null && t.handlers && (e.context.handlers.toggleChecked = Ga.bind(null, e)), (r = e.context) != null && r.fns && (e.context.fns.isChecked = Qa.bind(null, e));
  }), e.hook.prop(Br(e));
}
function el(e, t) {
  if (nt(t))
    return !1;
  e.context && e.context.value;
  const r = "__original" in t ? t.__original : t.value;
  return Array.isArray(e._value) ? e._value.some((n) => Ae(n, r)) : (e._value === void 0 || e._value === null && !Gr(e.props.options, null)) && t.attrs && t.attrs["data-is-placeholder"] ? !0 : Ae(r, e._value);
}
function Gr(e, t) {
  return e.some((r) => nt(r) ? Gr(r.options, t) : ("__original" in r ? r.__original : r.value) === t);
}
async function tl(e, t) {
  var r;
  typeof ((r = e.props.attrs) == null ? void 0 : r.onChange) == "function" && (await new Promise((n) => setTimeout(n, 0)), await e.settled, e.props.attrs.onChange(t));
}
function rl(e, t) {
  const r = t.target, n = r.hasAttribute("multiple") ? Array.from(r.selectedOptions).map(
    (s) => pe(e.props.options, s.value)
  ) : pe(e.props.options, r.value);
  e.input(n);
}
function Xt(e, t) {
  return e.some(
    (r) => r.attrs && r.attrs["data-is-placeholder"]
  ) ? e : [
    {
      label: t,
      value: "",
      attrs: {
        hidden: !0,
        disabled: !0,
        "data-is-placeholder": "true"
      }
    },
    ...e
  ];
}
function Qr(e) {
  const t = e.length > 0 ? e[0] : void 0;
  if (t)
    return nt(t) ? Qr(t.options) : "__original" in t ? t.__original : t.value;
}
function nl(e) {
  e.on("created", () => {
    var r, n, s;
    const t = U((r = e.props.attrs) == null ? void 0 : r.multiple);
    !t && e.props.placeholder && Array.isArray(e.props.options) && (e.hook.prop(({ prop: i, value: a }, l) => (i === "options" && (a = Xt(a, e.props.placeholder)), l({ prop: i, value: a }))), e.props.options = Xt(
      e.props.options,
      e.props.placeholder
    )), t ? e.value === void 0 && e.input([], !1) : e.context && !e.context.options && (e.props.attrs = Object.assign({}, e.props.attrs, {
      value: e._value
    }), e.on("input", ({ payload: i }) => {
      e.props.attrs = Object.assign({}, e.props.attrs, {
        value: i
      });
    })), (n = e.context) != null && n.handlers && (e.context.handlers.selectInput = rl.bind(null, e), e.context.handlers.onChange = tl.bind(null, e)), (s = e.context) != null && s.fns && (e.context.fns.isSelected = el.bind(null, e), e.context.fns.showPlaceholder = (i, a) => {
      if (!Array.isArray(e.props.options))
        return !1;
      const l = e.props.options.some(
        (o) => {
          if (o.attrs && "data-is-placeholder" in o.attrs)
            return !1;
          const y = "__original" in o ? o.__original : o.value;
          return q(i, y);
        }
      );
      return a && !l ? !0 : void 0;
    });
  }), e.hook.input((t, r) => {
    var n, s, i;
    return !e.props.placeholder && t === void 0 && Array.isArray((n = e.props) == null ? void 0 : n.options) && e.props.options.length && !U((i = (s = e.props) == null ? void 0 : s.attrs) == null ? void 0 : i.multiple) && (t = Qr(e.props.options)), r(t);
  });
}
// @__NO_SIDE_EFFECTS__
function $t(e) {
  return !!(ye(e) && e.if && e.if.startsWith("$slots.") && typeof e.then == "string" && e.then.startsWith("$slots.") && "else" in e);
}
// @__NO_SIDE_EFFECTS__
function sl(e, t = {}) {
  const r = /* @__PURE__ */ ue(
    /* @__PURE__ */ Ce(
      /* @__PURE__ */ Fe("$label"),
      /* @__PURE__ */ Ne(/* @__PURE__ */ D("prefix"), /* @__PURE__ */ X(), e(), /* @__PURE__ */ ee(), /* @__PURE__ */ D("suffix"))
    ),
    /* @__PURE__ */ Q("$help"),
    /* @__PURE__ */ oe(/* @__PURE__ */ le("$message.value"))
  );
  return (n = {}) => r(ae(t, n));
}
// @__NO_SIDE_EFFECTS__
function se(e, t, r) {
  const n = (s) => {
    const i = t(s);
    if (r || Ze(i) && "if" in i || /* @__PURE__ */ $t(i)) {
      const a = {
        if: e,
        then: i
      };
      return r && (a.else = r(s)), a;
    } else
      /* @__PURE__ */ $t(i) ? Object.assign(i.else, { if: e }) : Ze(i) && Object.assign(i, { if: e });
    return i;
  };
  return n._s = xe(), n;
}
// @__NO_SIDE_EFFECTS__
function $e(e, t) {
  const r = (n) => {
    const s = e({});
    return /* @__PURE__ */ $t(s) ? (Array.isArray(s.else) || (s.else = /* @__PURE__ */ Oe(
      /* @__PURE__ */ Oe(s.else, t),
      e._s ? n[e._s] : {}
    )), s) : /* @__PURE__ */ Oe(
      /* @__PURE__ */ Oe(s, t),
      e._s ? n[e._s] : {}
    );
  };
  return r._s = e._s, r;
}
var er = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ ue(
    /* @__PURE__ */ oe(/* @__PURE__ */ le("$message.value")),
    /* @__PURE__ */ Ce(
      /* @__PURE__ */ Ea(
        /* @__PURE__ */ D("prefix"),
        /* @__PURE__ */ X(),
        /* @__PURE__ */ Oa("$label || $ui.submit.value"),
        /* @__PURE__ */ ee(),
        /* @__PURE__ */ D("suffix")
      )
    ),
    /* @__PURE__ */ Q("$help")
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "button",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [We("submit"), Ya],
  /**
   * A key to use for memoizing the schema. This is used to prevent the schema
   * from needing to be stringified when performing a memo lookup.
   */
  schemaMemoKey: "h6st4epl3j8"
}, il = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ ue(
    /* @__PURE__ */ se(
      "$options == undefined",
      /**
       * Single checkbox structure.
       */
      /* @__PURE__ */ Qe(
        /* @__PURE__ */ Je(/* @__PURE__ */ X(), /* @__PURE__ */ Ye(), /* @__PURE__ */ Xe(/* @__PURE__ */ D("decorator")), /* @__PURE__ */ ee()),
        /* @__PURE__ */ $e(/* @__PURE__ */ Ge("$label"), {
          if: "$label"
        })
      ),
      /**
       * Multi checkbox structure.
       */
      /* @__PURE__ */ Wr(
        /* @__PURE__ */ Kr("$label"),
        /* @__PURE__ */ Q("$help"),
        /* @__PURE__ */ zr(
          /* @__PURE__ */ Tr(
            /* @__PURE__ */ Qe(
              /* @__PURE__ */ Je(
                /* @__PURE__ */ X(),
                /* @__PURE__ */ $e(/* @__PURE__ */ Ye(), {
                  bind: "$option.attrs",
                  attrs: {
                    id: "$option.attrs.id",
                    value: "$option.value",
                    checked: "$fns.isChecked($option.value)"
                  }
                }),
                /* @__PURE__ */ Xe(/* @__PURE__ */ D("decorator")),
                /* @__PURE__ */ ee()
              ),
              /* @__PURE__ */ $e(/* @__PURE__ */ Ge("$option.label"), {
                if: "$option.label"
              })
            ),
            /* @__PURE__ */ qr("$option.help")
          )
        )
      )
    ),
    // Help text only goes under the input when it is a single.
    /* @__PURE__ */ se("$options == undefined && $help", /* @__PURE__ */ Q("$help")),
    /* @__PURE__ */ oe(/* @__PURE__ */ le("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "box",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["options", "onValue", "offValue", "optionsLoader"],
  /**
   * Additional features that should be added to your input
   */
  features: [
    Mt,
    Ha,
    be("decorator", "checkboxDecorator")
  ],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "qje02tb3gu8"
}, al = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ ue(
    /* @__PURE__ */ Ce(
      /* @__PURE__ */ Fe("$label"),
      /* @__PURE__ */ Ne(
        /* @__PURE__ */ D("prefix", "label"),
        /* @__PURE__ */ X(),
        /* @__PURE__ */ Ma(),
        /* @__PURE__ */ Ra(
          /* @__PURE__ */ Ia(
            /* @__PURE__ */ D("fileItem"),
            /* @__PURE__ */ ja("$file.name"),
            /* @__PURE__ */ se(
              "$value.length === 1",
              /* @__PURE__ */ Zt(
                /* @__PURE__ */ D("fileRemove"),
                '$ui.remove.value + " " + $file.name'
              )
            )
          )
        ),
        /* @__PURE__ */ se("$value.length > 1", /* @__PURE__ */ Zt("$ui.removeAll.value")),
        /* @__PURE__ */ Na(/* @__PURE__ */ D("noFiles"), "$ui.noFiles.value"),
        /* @__PURE__ */ ee(),
        /* @__PURE__ */ D("suffix")
      )
    ),
    /* @__PURE__ */ Q("$help"),
    /* @__PURE__ */ oe(/* @__PURE__ */ le("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "text",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [
    Ua,
    be("fileItem", "fileItem"),
    be("fileRemove", "fileRemove"),
    be("noFiles", "noFiles")
  ],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "9kqc4852fv8"
}, ll = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Va(
    "$slots.default",
    /* @__PURE__ */ oe(/* @__PURE__ */ le("$message.value")),
    /* @__PURE__ */ Pa(/* @__PURE__ */ La())
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "group",
  /**
   * An array of extra props to accept for this input.
   */
  props: [
    "actions",
    "submit",
    "submitLabel",
    "submitAttrs",
    "submitBehavior",
    "incompleteMessage"
  ],
  /**
   * Additional features that should be added to your input
   */
  features: [Za, Rt],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "5bg016redjo"
}, ol = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ It("$slots.default"),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "group",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [Rt, Ur]
}, ul = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Hr(),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [Jr]
}, fl = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ It("$slots.default"),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "list",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["sync", "dynamic"],
  /**
   * Additional features that should be added to your input
   */
  features: [Rt, Ur]
}, cl = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ It(),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: []
}, pl = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ ue(
    /* @__PURE__ */ se(
      "$options == undefined",
      /**
       * Single radio structure.
       */
      /* @__PURE__ */ Qe(
        /* @__PURE__ */ Je(/* @__PURE__ */ X(), /* @__PURE__ */ Ye(), /* @__PURE__ */ Xe(/* @__PURE__ */ D("decorator")), /* @__PURE__ */ ee()),
        /* @__PURE__ */ $e(/* @__PURE__ */ Ge("$label"), {
          if: "$label"
        })
      ),
      /**
       * Multi radio structure.
       */
      /* @__PURE__ */ Wr(
        /* @__PURE__ */ Kr("$label"),
        /* @__PURE__ */ Q("$help"),
        /* @__PURE__ */ zr(
          /* @__PURE__ */ Tr(
            /* @__PURE__ */ Qe(
              /* @__PURE__ */ Je(
                /* @__PURE__ */ X(),
                /* @__PURE__ */ $e(/* @__PURE__ */ Ye(), {
                  bind: "$option.attrs",
                  attrs: {
                    id: "$option.attrs.id",
                    value: "$option.value",
                    checked: "$fns.isChecked($option.value)"
                  }
                }),
                /* @__PURE__ */ Xe(/* @__PURE__ */ D("decorator")),
                /* @__PURE__ */ ee()
              ),
              /* @__PURE__ */ $e(/* @__PURE__ */ Ge("$option.label"), {
                if: "$option.label"
              })
            ),
            /* @__PURE__ */ qr("$option.help")
          )
        )
      )
    ),
    // Help text only goes under the input when it is a single.
    /* @__PURE__ */ se("$options == undefined && $help", /* @__PURE__ */ Q("$help")),
    /* @__PURE__ */ oe(/* @__PURE__ */ le("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "box",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["options", "onValue", "offValue", "optionsLoader"],
  /**
   * Additional features that should be added to your input
   */
  features: [Mt, Xa, be("decorator", "radioDecorator")],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "qje02tb3gu8"
}, ml = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ ue(
    /* @__PURE__ */ Ce(
      /* @__PURE__ */ Fe("$label"),
      /* @__PURE__ */ Ne(
        /* @__PURE__ */ D("prefix"),
        /* @__PURE__ */ X(),
        /* @__PURE__ */ Da(
          /* @__PURE__ */ se(
            "$slots.default",
            () => "$slots.default",
            /* @__PURE__ */ Jt(
              /* @__PURE__ */ se(
                "$option.group",
                /* @__PURE__ */ Fa(/* @__PURE__ */ Jt(/* @__PURE__ */ Yt("$option.label"))),
                /* @__PURE__ */ Yt("$option.label")
              )
            )
          )
        ),
        /* @__PURE__ */ se("$attrs.multiple !== undefined", () => "", /* @__PURE__ */ D("select")),
        /* @__PURE__ */ ee(),
        /* @__PURE__ */ D("suffix")
      )
    ),
    /* @__PURE__ */ Q("$help"),
    /* @__PURE__ */ oe(/* @__PURE__ */ le("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["options", "placeholder", "optionsLoader"],
  /**
   * Additional features that should be added to your input
   */
  features: [Mt, nl, be("select", "select")],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "cb119h43krg"
}, dl = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ ue(
    /* @__PURE__ */ Ce(
      /* @__PURE__ */ Fe("$label"),
      /* @__PURE__ */ Ne(
        /* @__PURE__ */ D("prefix", "label"),
        /* @__PURE__ */ X(),
        /* @__PURE__ */ qa(),
        /* @__PURE__ */ ee(),
        /* @__PURE__ */ D("suffix")
      )
    ),
    /* @__PURE__ */ Q("$help"),
    /* @__PURE__ */ oe(/* @__PURE__ */ le("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [Ja],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "b1n0td79m9g"
}, T = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ ue(
    /* @__PURE__ */ Ce(
      /* @__PURE__ */ Fe("$label"),
      /* @__PURE__ */ Ne(
        /* @__PURE__ */ D("prefix", "label"),
        /* @__PURE__ */ X(),
        /* @__PURE__ */ Hr(),
        /* @__PURE__ */ ee(),
        /* @__PURE__ */ D("suffix")
      )
    ),
    /* @__PURE__ */ Q("$help"),
    /* @__PURE__ */ oe(/* @__PURE__ */ le("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "text",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [Jr],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "c3cc4kflsg"
}, yl = {
  button: er,
  submit: er,
  checkbox: il,
  file: al,
  form: ll,
  group: ol,
  hidden: ul,
  list: fl,
  meta: cl,
  radio: pl,
  select: ml,
  textarea: dl,
  text: T,
  color: T,
  date: T,
  datetimeLocal: T,
  email: T,
  month: T,
  number: T,
  password: T,
  search: T,
  tel: T,
  time: T,
  url: T,
  week: T,
  range: T
}, Y = void 0, G = null, et, Xr = !1, Me = !1, vl = /* @__PURE__ */ new Promise((e) => {
  et = () => {
    Xr = !0, e();
  };
}), ie = typeof window < "u" && typeof fetch < "u";
Y = ie ? /* @__PURE__ */ getComputedStyle(document.documentElement) : void 0;
var ve = {}, at = {};
function hl(e, t, r, n) {
  t && Object.assign(ve, t), ie && !Me && (Y != null && Y.getPropertyValue("--formkit-theme")) ? (et(), Me = !0) : e && !Me && ie ? gl(e) : !Me && ie && et();
  const s = function(a) {
    var l, o;
    a.addProps(["iconLoader", "iconLoaderUrl"]), a.props.iconHandler = tr(
      (l = a.props) != null && l.iconLoader ? a.props.iconLoader : n,
      (o = a.props) != null && o.iconLoaderUrl ? a.props.iconLoaderUrl : r
    ), _l(a, a.props.iconHandler), a.on("created", () => {
      var y, v;
      (y = a == null ? void 0 : a.context) != null && y.handlers && (a.context.handlers.iconClick = (g) => {
        const E = `on${g.charAt(0).toUpperCase()}${g.slice(1)}IconClick`, h = a.props[E];
        if (h && typeof h == "function")
          return (b) => h(a, b);
      }), (v = a == null ? void 0 : a.context) != null && v.fns && (a.context.fns.iconRole = (g) => {
        const E = `on${g.charAt(0).toUpperCase()}${g.slice(1)}IconClick`;
        return typeof a.props[E] == "function" ? "button" : null;
      });
    });
  };
  return s.iconHandler = tr(n, r), s;
}
function gl(e) {
  if (!(!e || !ie || typeof getComputedStyle != "function") && (Me = !0, G = document.getElementById("formkit-theme"), e && // if we have a window object
  ie && // we don't have an existing theme OR the theme being set up is different
  (!(Y != null && Y.getPropertyValue("--formkit-theme")) && !G || G != null && G.getAttribute("data-theme") && (G == null ? void 0 : G.getAttribute("data-theme")) !== e))) {
    const r = `https://cdn.jsdelivr.net/npm/@formkit/themes@${Be.startsWith("__") ? "latest" : Be}/dist/${e}/theme.css`, n = document.createElement("link");
    n.type = "text/css", n.rel = "stylesheet", n.id = "formkit-theme", n.setAttribute("data-theme", e), n.onload = () => {
      Y = getComputedStyle(document.documentElement), et();
    }, document.head.appendChild(n), n.href = r, G && G.remove();
  }
}
function tr(e, t) {
  return (r) => {
    if (typeof r != "string")
      return;
    if (r.startsWith("<svg"))
      return r;
    const n = r.startsWith("default:");
    r = n ? r.split(":")[1] : r;
    const s = r in ve;
    let i;
    if (s)
      return ve[r];
    if (!at[r]) {
      if (i = bl(r), i = ie && typeof i > "u" ? Promise.resolve(i) : i, i instanceof Promise)
        at[r] = i.then((a) => !a && typeof r == "string" && !n ? i = typeof e == "function" ? e(r) : $l(r, t) : a).then((a) => (typeof r == "string" && (ve[n ? `default:${r}` : r] = a), a));
      else if (typeof i == "string")
        return ve[n ? `default:${r}` : r] = i, i;
    }
    return at[r];
  };
}
function bl(e) {
  if (ie)
    return Xr ? rr(e) : vl.then(() => rr(e));
}
function rr(e) {
  const t = Y == null ? void 0 : Y.getPropertyValue(`--fk-icon-${e}`);
  if (t) {
    const r = atob(t);
    if (r.startsWith("<svg"))
      return ve[e] = r, r;
  }
}
function $l(e, t) {
  const r = Be.startsWith("__") ? "latest" : Be, n = typeof t == "function" ? t(e) : `https://cdn.jsdelivr.net/npm/@formkit/icons@${r}/dist/icons/${e}.svg`;
  if (ie)
    return fetch(`${n}`).then(async (s) => {
      const i = await s.text();
      if (i.startsWith("<svg"))
        return i;
    }).catch((s) => {
      console.error(s);
    });
}
function _l(e, t) {
  const r = /^[a-zA-Z-]+(?:-icon|Icon)$/;
  Object.keys(e.props).filter((s) => r.test(s)).forEach((s) => wl(e, t, s));
}
function wl(e, t, r) {
  const n = e.props[r], s = t(n), i = `_raw${r.charAt(0).toUpperCase()}${r.slice(1)}`, a = `on${r.charAt(0).toUpperCase()}${r.slice(1)}Click`;
  if (e.addProps([i, a]), e.on(`prop:${r}`, kl), s instanceof Promise)
    return s.then((l) => {
      e.props[i] = l;
    });
  e.props[i] = s;
}
function kl(e) {
  var a;
  const t = e.origin, r = e.payload, n = (a = t == null ? void 0 : t.props) == null ? void 0 : a.iconHandler, s = e.name.split(":")[1], i = `_raw${s.charAt(0).toUpperCase()}${s.slice(1)}`;
  if (n && typeof n == "function") {
    const l = n(r);
    if (l instanceof Promise)
      return l.then((o) => {
        t.props[i] = o;
      });
    t.props[i] = l;
  }
}
var nr = {
  /**
   * FormKit errors:
   */
  100: ({ data: e }) => `Only groups, lists, and forms can have children (${e.name}).`,
  101: ({ data: e }) => `You cannot directly modify the store (${e.name}). See: https://formkit.com/advanced/core#message-store`,
  102: ({
    data: [e, t]
  }) => `You cannot directly assign node.${t} (${e.name})`,
  103: ({ data: [e] }) => `Schema expressions cannot start with an operator (${e})`,
  104: ({ data: [e, t] }) => `Schema expressions cannot end with an operator (${e} in "${t}")`,
  105: ({ data: e }) => `Invalid schema expression: ${e}`,
  106: ({ data: e }) => `Cannot submit because (${e}) is not in a form.`,
  107: ({ data: [e, t] }) => `Cannot set ${e.name} to non object value: ${t}`,
  108: ({ data: [e, t] }) => `Cannot set ${e.name} to non array value: ${t}`,
  /**
   * Input specific errors:
   */
  300: ({ data: [e] }) => `Cannot set behavior prop to overscroll (on ${e.name} input) when options prop is a function.`,
  /**
   * FormKit vue errors:
   */
  600: ({ data: e }) => `Unknown input type${typeof e.props.type == "string" ? ' "' + e.props.type + '"' : ""} ("${e.name}")`,
  601: ({ data: e }) => `Input definition${typeof e.props.type == "string" ? ' "' + e.props.type + '"' : ""} is missing a schema or component property (${e.name}).`
}, sr = {
  /**
   * Core warnings:
   */
  150: ({ data: e }) => `Schema function "${e}()" is not a valid function.`,
  151: ({ data: e }) => `No form element with id: ${e}`,
  152: ({ data: e }) => `No input element with id: ${e}`,
  /**
   * Input specific warnings:
   */
  350: ({
    data: { node: e, inputType: t }
  }) => `Invalid options prop for ${e.name} input (${t}). See https://formkit.com/inputs/${t}`,
  /**
   * Vue warnings:
   */
  650: 'Schema "$get()" must use the id of an input to access.',
  651: ({ data: e }) => `Cannot setErrors() on "${e}" because no such id exists.`,
  652: ({ data: e }) => `Cannot clearErrors() on "${e}" because no such id exists.`,
  /**
   * Deprecation warnings:
   */
  800: ({ data: e }) => `${e} is deprecated.`
}, Sl = (e, t) => {
  if (e.code in nr) {
    const r = nr[e.code];
    e.message = typeof r == "function" ? r(e) : r;
  }
  return t(e);
}, ir = !1;
function Al() {
  ir || (At(Sl), xt(xl), ir = !0);
}
var xl = (e, t) => {
  if (e.code in sr) {
    const r = sr[e.code];
    e.message = typeof r == "function" ? r(e) : r;
  }
  return t(e);
}, Cl = Object.defineProperty, Pl = Object.getOwnPropertyNames, en = (e, t) => function() {
  return e && (t = (0, e[Pl(e)[0]])(e = 0)), t;
}, El = (e, t) => {
  for (var r in t)
    Cl(e, r, { get: t[r], enumerable: !0 });
}, ar, tn, rn = en({
  "packages/vue/src/bindings.ts"() {
    ar = function(t) {
      t.ledger.count("blocking", (f) => f.blocking);
      const r = z(!t.ledger.value("blocking"));
      t.ledger.count("errors", (f) => f.type === "error");
      const n = z(!!t.ledger.value("errors"));
      let s = !1;
      dn(() => {
        s = !0;
      });
      const i = Ee(
        t.store.reduce((f, k) => (k.visible && (f[k.key] = k), f), {})
      ), a = z(
        t.props.validationVisibility || (t.props.type === "checkbox" ? "dirty" : "blur")
      );
      t.on("prop:validationVisibility", ({ payload: f }) => {
        a.value = f;
      });
      const l = z(a.value === "live"), o = z(!1), y = (f) => {
        o.value = (f ?? []).some(
          (k) => k.name === "required"
        );
      };
      y(t.props.parsedRules), t.on("prop:parsedRules", ({ payload: f }) => y(f));
      const v = z(t.children.map((f) => f.uid)), g = re(() => {
        if (!p.state)
          return !1;
        if (p.state.submitted)
          return !0;
        if (!l.value && !p.state.settled)
          return !1;
        switch (a.value) {
          case "live":
            return !0;
          case "blur":
            return p.state.blurred;
          case "dirty":
            return p.state.dirty;
          default:
            return !1;
        }
      }), E = re(() => p.state.failing && g.value), h = re(() => p && b.value ? r.value && !n.value : p.state.dirty && !B(p.value)), b = z(
        Array.isArray(t.props.parsedRules) && t.props.parsedRules.length > 0
      );
      t.on("prop:parsedRules", ({ payload: f }) => {
        b.value = Array.isArray(f) && f.length > 0;
      });
      const c = re(() => {
        const f = {};
        for (const k in i) {
          const x = i[k];
          (x.type !== "validation" || g.value) && (f[k] = x);
        }
        return f;
      }), m = Ee(
        t.store.reduce((f, k) => (k.type === "ui" && k.visible && (f[k.key] = k), f), {})
      ), d = re(() => !p.state.failing), _ = Ee({}), S = new Proxy(_, {
        get(...f) {
          if (!t)
            return "";
          const [k, x] = f;
          let N = Reflect.get(...f);
          return !N && typeof x == "string" && !C(k, x) && !x.startsWith("__v") && rt(t).watch((F) => {
            const fe = typeof F.config.rootClasses == "function" ? F.config.rootClasses(x, F) : {}, J = F.config.classes ? ze(x, F, F.config.classes[x]) : {}, me = ze(
              x,
              F,
              F.props[`_${x}Class`]
            ), ce = ze(
              x,
              F,
              F.props[`${x}Class`]
            );
            N = zs(
              F,
              x,
              fe,
              J,
              me,
              ce
            ), k[x] = N ?? "";
          }), N;
        }
      });
      t.on("prop:rootClasses", () => {
        const f = Object.keys(_);
        for (const k of f)
          delete _[k];
      });
      const $ = re(() => {
        if (!t)
          return;
        const f = [];
        p.help && f.push(`help-${t.props.id}`);
        for (const k in c.value)
          f.push(`${t.props.id}-${k}`);
        return f.length ? f.join(" ") : void 0;
      }), w = z(t.value), u = z(t.value), p = Ee({
        _value: u,
        attrs: t.props.attrs,
        disabled: t.props.disabled,
        describedBy: $,
        fns: {
          length: (f) => Object.keys(f).length,
          number: (f) => Number(f),
          string: (f) => String(f),
          json: (f) => JSON.stringify(f),
          eq: q
        },
        handlers: {
          blur: (f) => {
            t && (t.store.set(
              /* @__PURE__ */ K({ key: "blurred", visible: !1, value: !0 })
            ), typeof t.props.attrs.onBlur == "function" && t.props.attrs.onBlur(f));
          },
          touch: () => {
            var x;
            const f = p.dirtyBehavior === "compare";
            if ((x = t.store.dirty) != null && x.value && !f)
              return;
            const k = !q(t.props._init, t._value);
            !k && !f || t.store.set(
              /* @__PURE__ */ K({ key: "dirty", visible: !1, value: k })
            );
          },
          DOMInput: (f) => {
            t.input(f.target.value), t.emit("dom-input-event", f);
          }
        },
        help: t.props.help,
        id: t.props.id,
        items: v,
        label: t.props.label,
        messages: c,
        didMount: !1,
        node: tt(t),
        options: t.props.options,
        defaultMessagePlacement: !0,
        slots: t.props.__slots,
        state: {
          blurred: !1,
          complete: h,
          dirty: !1,
          empty: B(w),
          submitted: !1,
          settled: t.isSettled,
          valid: r,
          invalid: E,
          errors: n,
          rules: b,
          validationVisible: g,
          required: o,
          failing: !1,
          passing: d
        },
        type: t.props.type,
        family: t.props.family,
        ui: m,
        value: w,
        classes: S
      });
      t.on("created", () => {
        q(p.value, t.value) || (u.value = t.value, w.value = t.value, De(w), De(u)), (async () => (await t.settled, t && (t.props._init = H(t.value))))();
      }), t.on("mounted", () => {
        p.didMount = !0;
      }), t.on("settled", ({ payload: f }) => {
        p.state.settled = f;
      });
      function P(f) {
        (Array.isArray(f) ? f : Object.keys(f)).forEach((x) => {
          x = ge(x), C(p, x) || (p[x] = t.props[x]), t.on(`prop:${x}`, ({ payload: N }) => {
            p[x] = N;
          });
        });
      }
      P((() => {
        const f = [
          "__root",
          "help",
          "label",
          "disabled",
          "options",
          "type",
          "attrs",
          "preserve",
          "preserveErrors",
          "id",
          "dirtyBehavior"
        ], k = /^[a-zA-Z-]+(?:-icon|Icon)$/, x = Object.keys(t.props).filter((N) => k.test(N));
        return f.concat(x);
      })());
      function j(f) {
        f.props && P(f.props);
      }
      t.props.definition && j(t.props.definition), t.on("added-props", ({ payload: f }) => P(f)), t.on("input", ({ payload: f }) => {
        t.type !== "input" && !ft(f) && !Vt(f) ? u.value = ct(f) : (u.value = f, De(u));
      }), t.on("commitRaw", ({ payload: f }) => {
        t.type !== "input" && !ft(f) && !Vt(f) ? w.value = u.value = ct(f) : (w.value = u.value = f, De(w)), t.emit("modelUpdated");
      }), t.on("commit", ({ payload: f }) => {
        var k;
        if ((!p.state.dirty || p.dirtyBehavior === "compare") && t.isCreated && s)
          if (!((k = t.store.validating) != null && k.value))
            p.handlers.touch();
          else {
            const x = t.on("message-removed", ({ payload: N }) => {
              N.key === "validating" && (p.handlers.touch(), t.off(x));
            });
          }
        h && t.type === "input" && n.value && !U(t.props.preserveErrors) && t.store.filter(
          (x) => {
            var N;
            return !(x.type === "error" && ((N = x.meta) == null ? void 0 : N.autoClear) === !0);
          }
        ), t.type === "list" && t.sync && (v.value = t.children.map((x) => x.uid)), p.state.empty = B(f);
      });
      const M = async (f) => {
        f.type === "ui" && f.visible && !f.meta.showAsMessage ? m[f.key] = f : f.visible ? i[f.key] = f : f.type === "state" && (p.state[f.key] = !!f.value);
      };
      t.on("message-added", (f) => M(f.payload)), t.on("message-updated", (f) => M(f.payload)), t.on("message-removed", ({ payload: f }) => {
        delete m[f.key], delete i[f.key], delete p.state[f.key];
      }), t.on("settled:blocking", () => {
        r.value = !0;
      }), t.on("unsettled:blocking", () => {
        r.value = !1;
      }), t.on("settled:errors", () => {
        n.value = !1;
      }), t.on("unsettled:errors", () => {
        n.value = !0;
      }), he(g, (f) => {
        f && (l.value = !0);
      }), t.context = p, t.emit("context", t, !1), t.on("destroyed", () => {
        t.context = void 0, t = null;
      });
    }, tn = ar;
  }
}), Ol = {};
El(Ol, {
  defaultConfig: () => nn
});
var nn, Ml = en({
  "packages/vue/src/defaultConfig.ts"() {
    rn(), nn = (e = {}) => {
      Al();
      const {
        rules: t = {},
        locales: r = {},
        inputs: n = {},
        messages: s = {},
        locale: i = void 0,
        theme: a = void 0,
        iconLoaderUrl: l = void 0,
        iconLoader: o = void 0,
        icons: y = {},
        ...v
      } = e, g = la({
        ...aa,
        ...t || {}
      }), E = Sa(
        ae({ en: ka, ...r || {} }, s)
      ), h = Aa(yl, n), b = hl(a, y, l, o);
      return ae(
        {
          plugins: [h, b, tn, E, g],
          ...i ? { config: { locale: i } } : {}
        },
        v || {},
        !0
      );
    };
  }
}), Il = typeof window > "u", lt = /* @__PURE__ */ new Map();
function Rl(e, t) {
  var r;
  !Il || !e || (lt.has(e) || lt.set(e, /* @__PURE__ */ new Set()), (r = lt.get(e)) == null || r.add(t));
}
var sn = typeof window > "u", Re = {}, _e = {}, L, ne = /* @__PURE__ */ new WeakMap(), jl = "__raw__", Vl = /[a-zA-Z0-9\-][cC]lass$/;
function Nl(e, t) {
  const r = z(null);
  if (e === "get") {
    const s = {};
    return r.value = Fl.bind(null, s), r;
  }
  const n = e.split(".");
  return te(() => {
    r.value = jt(
      ft(t) ? t.value : t,
      n
    );
  }), r;
}
function jt(e, t) {
  if (Array.isArray(e)) {
    for (const s of e) {
      const i = s !== !1 && jt(s, t);
      if (i !== void 0)
        return i;
    }
    return;
  }
  let r, n = e;
  for (const s in t) {
    const i = t[s];
    if (typeof n != "object" || n === null) {
      r = void 0;
      break;
    }
    const a = n[i];
    if (Number(s) === t.length - 1 && a !== void 0) {
      r = typeof a == "function" ? a.bind(n) : a;
      break;
    }
    n = a;
  }
  return r;
}
function Fl(e, t) {
  if (typeof t != "string")
    return je(650);
  if (t in e || (e[t] = z(void 0)), e[t].value === void 0) {
    e[t].value = null;
    const r = gr(t);
    r && (e[t].value = r.context), Un(t, ({ payload: n }) => {
      e[t].value = Ve(n) ? n.context : n;
    });
  }
  return e[t].value;
}
function lr(e, t, r) {
  function n(h, b) {
    const c = g(Z(b.if), { if: !0 }), m = y(h, b.then), d = b.else ? y(h, b.else) : null;
    return [c, m, d];
  }
  function s(h, b) {
    var _, S;
    const c = g(Z(h.if));
    let m = () => b, d = () => b;
    return typeof h.then == "object" ? d = i(h.then, void 0) : typeof h.then == "string" && ((_ = h.then) != null && _.startsWith("$")) ? d = g(Z(h.then)) : d = () => h.then, C(h, "else") && (typeof h.else == "object" ? m = i(h.else) : typeof h.else == "string" && ((S = h.else) != null && S.startsWith("$")) ? m = g(Z(h.else)) : m = () => h.else), () => c() ? d() : m();
  }
  function i(h, b, c = {}) {
    const m = new Set(Object.keys(h || {})), d = b ? g(Z(b)) : () => ({}), _ = [
      (S) => {
        const $ = d();
        for (const w in $)
          m.has(w) || (S[w] = $[w]);
      }
    ];
    if (h) {
      if (ye(h))
        return s(
          h,
          c
        );
      for (let S in h) {
        const $ = h[S];
        let w;
        const u = typeof $ == "string";
        S.startsWith(jl) ? (S = S.substring(7), w = () => $) : u && $.startsWith("$") && $.length > 1 && !($.startsWith("$reset") && Vl.test(S)) ? w = g(Z($)) : typeof $ == "object" && ye($) ? w = s($, void 0) : typeof $ == "object" && we($) ? w = i($) : w = () => $, _.push((p) => {
          p[S] = w();
        });
      }
    }
    return () => {
      const S = Array.isArray(h) ? [] : {};
      return _.forEach(($) => $(S)), S;
    };
  }
  function a(h, b) {
    let c = null, m = () => null, d = !1, _ = null, S = null, $ = null, w = !1;
    const u = Ts(b);
    if (yt(u) ? (c = u.$el, m = u.$el !== "text" ? i(u.attrs, u.bind) : () => null) : vt(u) ? (typeof u.$cmp == "string" ? C(h, u.$cmp) ? c = h[u.$cmp] : (c = u.$cmp, w = !0) : c = u.$cmp, m = i(u.props, u.bind)) : ye(u) && ([d, _, S] = n(h, u)), !ye(u) && "if" in u ? d = g(Z(u.if)) : !ye(u) && c === null && (d = () => !0), "children" in u && u.children)
      if (typeof u.children == "string")
        if (u.children.startsWith("$slots."))
          c = c === "text" ? "slot" : c, _ = g(Z(u.children));
        else if (u.children.startsWith("$") && u.children.length > 1) {
          const p = g(Z(u.children));
          _ = () => String(p());
        } else
          _ = () => String(u.children);
      else if (Array.isArray(u.children))
        _ = y(h, u.children);
      else {
        const [p, P, R] = n(h, u.children);
        _ = (j) => p && p() ? P && P(j) : R && R(j);
      }
    if (vt(u))
      if (_) {
        const p = _;
        _ = (P) => ({
          default(R, j) {
            var k, x, N, V;
            const M = L;
            j && (L = j), R && ((k = ne.get(L)) == null || k.unshift(R)), P && ((x = ne.get(L)) == null || x.unshift(P));
            const f = p(P);
            return R && ((N = ne.get(L)) == null || N.shift()), P && ((V = ne.get(L)) == null || V.shift()), L = M, f;
          }
        }), _.slot = !0;
      } else
        _ = () => ({});
    if ("for" in u && u.for) {
      const p = u.for.length === 3 ? u.for[2] : u.for[1];
      $ = [
        typeof p == "string" && p.startsWith("$") ? g(Z(p)) : () => p,
        u.for[0],
        u.for.length === 3 ? String(u.for[1]) : null
      ];
    }
    return [d, c, m, _, S, $, w];
  }
  function l(h, b) {
    const c = h(b), m = L;
    return Object.keys(c).reduce((d, _) => {
      const S = c && c[_];
      return d[_] = ($) => S && S($, m) || null, d;
    }, {});
  }
  function o(h, b) {
    const [c, m, d, _, S, $, w] = a(h, b);
    let u = (p) => {
      if (c && m === null && _)
        return c() ? _(p) : S && S(p);
      if (m && (!c || c())) {
        if (m === "text" && _)
          return yn(String(_()));
        if (m === "slot" && _)
          return _(p);
        const P = w ? vn(m) : m, R = _ != null && _.slot ? l(_, p) : null;
        return Ke(
          P,
          d(),
          R || (_ ? _(p) : [])
        );
      }
      return typeof S == "function" ? S(p) : S;
    };
    if ($) {
      const p = u, [P, R, j] = $;
      u = () => {
        const M = P(), f = Number.isFinite(M) ? Array(Number(M)).fill(0).map((V, F) => F) : M, k = [];
        if (typeof f != "object")
          return null;
        const x = ne.get(L) || [], N = Array.isArray(f);
        for (const V in f) {
          if (N && V in Array.prototype)
            continue;
          const F = Object.defineProperty(
            {
              ...x.reduce(
                (fe, J) => fe.__idata ? { ...fe, ...J } : J,
                {}
              ),
              [R]: f[V],
              ...j !== null ? { [j]: N ? Number(V) : V } : {}
            },
            "__idata",
            { enumerable: !1, value: !0 }
          );
          x.unshift(F), k.push(p.bind(null, F)()), x.shift();
        }
        return k;
      };
    }
    return u;
  }
  function y(h, b) {
    if (Array.isArray(b)) {
      const m = b.map(o.bind(null, h));
      return (d) => m.map((_) => _(d));
    }
    const c = o(h, b);
    return (m) => c(m);
  }
  const v = [];
  function g(h, b = {}) {
    const c = /* @__PURE__ */ new WeakMap();
    return v.push((m, d) => {
      c.set(
        d,
        h.provide((_) => m(_, b))
      );
    }), () => c.get(L)();
  }
  function E(h, b) {
    r ?? (r = ln(t));
    const [c, m] = C(Re, r) ? Re[r] : [y(e, t), v];
    return sn || (_e[r] ?? (_e[r] = 0), _e[r]++, Re[r] = [c, m]), m.forEach((d) => {
      d(h, b);
    }), () => (L = b, c());
  }
  return E;
}
function an(e, t) {
  const r = ne.get(L) || [];
  let n;
  return r.length && (n = jt(r, e.split("."))), n === void 0 ? t : n;
}
function Dl(e, t) {
  return new Proxy(e, {
    get(...r) {
      let n;
      const s = r[1];
      if (typeof s == "string") {
        const i = L;
        L = t, n = an(s, void 0), L = i;
      }
      return n !== void 0 ? n : Reflect.get(...r);
    }
  });
}
function or(e, t, r) {
  return e(
    (n, s = {}) => n.reduce((i, a) => {
      if (a.startsWith("slots.")) {
        const l = a.substring(6), o = () => t.slots && C(t.slots, l) && typeof t.slots[l] == "function";
        if (s.if)
          i[a] = o;
        else if (t.slots) {
          const y = Dl(t, r);
          i[a] = () => o() ? t.slots[l](y) : null;
        }
      } else {
        const l = Nl(a, t);
        i[a] = () => an(a, l.value);
      }
      return i;
    }, {}),
    r
  );
}
function ur(e, t, r) {
  if (t ?? (t = ln(e)), _e[t]--, _e[t] === 0) {
    delete _e[t];
    const [, n] = Re[t];
    delete Re[t], n.length = 0;
  }
  ne.delete(r);
}
function ln(e) {
  return JSON.stringify(e, (t, r) => typeof r == "function" ? r.toString() : r);
}
var on = /* @__PURE__ */ wt({
  name: "FormKitSchema",
  props: {
    schema: {
      type: [Array, Object],
      required: !0
    },
    data: {
      type: Object,
      default: () => ({})
    },
    library: {
      type: Object,
      default: () => ({})
    },
    memoKey: {
      type: String,
      required: !1
    }
  },
  emits: ["mounted"],
  setup(e, t) {
    var y;
    const r = ut();
    let n = {};
    ne.set(n, []);
    const s = { FormKit: tt(Wl), ...e.library };
    let i = lr(s, e.schema, e.memoKey), a, l;
    sn || he(
      () => e.schema,
      (v, g) => {
        var h;
        const E = n;
        n = {}, ne.set(n, []), i = lr(s, e.schema, e.memoKey), a = or(i, l, n), v === g && ((h = r == null ? void 0 : r.proxy) == null ? void 0 : h.$forceUpdate).call(h), ur(e.schema, e.memoKey, E);
      },
      { deep: !0 }
    ), te(() => {
      l = Object.assign(Ee(e.data ?? {}), {
        slots: t.slots
      }), t.slots, a = or(i, l, n);
    });
    function o() {
      ur(e.schema, e.memoKey, n), l && (l.node && l.node.destroy(), l.slots = null, l = null), a = null;
    }
    return cr(() => t.emit("mounted")), fn(o), Rl((y = ut()) == null ? void 0 : y.appContext.app, o), () => a ? a() : null;
  }
}), Ll = on, ql = typeof window > "u", _t = Symbol("FormKitParent"), Tl = Symbol("FormKitComponentCallback");
function zl(e, t) {
  const r = Yl(e, t);
  if (r.props.definition || W(600, r), r.props.definition.component)
    return () => {
      var y;
      return Ke(
        (y = r.props.definition) == null ? void 0 : y.component,
        {
          context: r.context
        },
        { ...t.slots }
      );
    };
  const n = z([]);
  let s = r.props.definition.schemaMemoKey;
  const i = () => {
    var v, g;
    const y = (g = (v = r.props) == null ? void 0 : v.definition) == null ? void 0 : g.schema;
    y || W(601, r), typeof y == "function" ? (n.value = y({ ...e.sectionsSchema || {} }), (s && e.sectionsSchema || "memoKey" in y && typeof y.memoKey == "string") && (s = (s ?? (y == null ? void 0 : y.memoKey)) + JSON.stringify(e.sectionsSchema))) : n.value = y;
  };
  i(), ql || r.on("schema", () => {
    s += "♻️", i();
  }), t.emit("node", r);
  const a = r.props.definition.library, l = {
    FormKit: tt(un),
    ...a,
    ...e.library ?? {}
  };
  function o() {
    r.emit("mounted");
  }
  return t.expose({ node: r }), () => Ke(
    on,
    {
      schema: n.value,
      data: r.context,
      onMounted: o,
      library: l,
      memoKey: s
    },
    { ...t.slots }
  );
}
var un = /* @__PURE__ */ wt(
  zl,
  {
    props: xa,
    inheritAttrs: !1
  }
), Wl = un, Kl = Symbol(), Hl = Symbol.for("FormKitOptions"), Ul = typeof window < "u", ot = [
  // Boolean props
  "ignore",
  "disabled",
  "preserve",
  // String props
  "help",
  "label",
  /^preserve(-e|E)rrors/,
  /^[a-z]+(?:-visibility|Visibility|-behavior|Behavior)$/,
  /^[a-zA-Z-]+(?:-class|Class)$/,
  "prefixIcon",
  "suffixIcon",
  /^[a-zA-Z-]+(?:-icon|Icon)$/
], Bl = ["disabled", "ignore", "preserve"];
function fr(e, t) {
  t.classes && Object.keys(t.classes).forEach(
    (r) => {
      typeof r == "string" && (e.props[`_${r}Class`] = t.classes[r], Ie(t.classes[r]) && r === "inner" && Object.values(t.classes[r]));
    }
  );
}
function Zl(e) {
  return e ? ["Submit", "SubmitRaw", "SubmitInvalid"].reduce(
    (r, n) => {
      const s = `on${n}`;
      return s in e && typeof e[s] == "function" && (r[s] = e[s]), r;
    },
    {}
  ) : {};
}
function Yl(e, t, r = {}) {
  const n = Object.assign({}, Pe(Hl) || {}, r), s = Pe(Kl, z(Ul ? document : void 0)), i = Pe(Tl, () => {
  }), a = ut(), l = Zl(a == null ? void 0 : a.vnode.props), o = ["modelValue", "model-value"].some(
    (u) => u in ((a == null ? void 0 : a.vnode.props) ?? {})
  );
  let y = !1;
  cr(() => {
    y = !0;
  });
  const v = e.modelValue !== void 0 ? e.modelValue : H(t.attrs.value);
  function g() {
    const u = {
      ...de(e),
      ...l,
      type: e.type ?? "text",
      __root: s.value,
      __slots: t.slots
    }, p = Nt(de(t.attrs), ot);
    p.key || (p.key = xe()), u.attrs = p;
    const P = Ft(de(t.attrs), ot);
    for (const j in P)
      Bl.includes(j) && P[j] === "" && (P[j] = !0), u[ge(j)] = P[j];
    const R = { props: {} };
    return fr(R, e), Object.assign(u, R.props), typeof u.type != "string" && (u.definition = u.type, delete u.type), u;
  }
  const E = g(), h = E.ignore ? null : e.parent || Pe(_t, null), b = Ls(
    ae(
      n || {},
      {
        name: e.name || void 0,
        value: v,
        parent: h,
        plugins: (n.plugins || []).concat(e.plugins ?? []),
        config: e.config || {},
        props: E,
        index: e.index,
        sync: !!U(t.attrs.sync || t.attrs.dynamic)
      },
      !1,
      !0
    )
  );
  i(b), b.props.definition || W(600, b);
  const c = z(
    new Set(
      Array.isArray(b.props.__propDefs) ? b.props.__propDefs : Object.keys(b.props.__propDefs ?? {})
    )
  );
  b.on(
    "added-props",
    ({ payload: u }) => {
      (Array.isArray(u) ? u : Object.keys(u ?? {})).forEach((P) => c.value.add(P));
    }
  );
  const m = re(
    () => ot.concat([...c.value]).reduce((u, p) => (typeof p == "string" ? (u.push(ge(p)), u.push(mr(p))) : u.push(p), u), [])
  );
  te(() => fr(b, e));
  const d = de(e);
  for (const u in d)
    he(
      () => e[u],
      () => {
        e[u] !== void 0 && (b.props[u] = e[u]);
      }
    );
  te(() => {
    b.props.__root = s.value;
  });
  const _ = /* @__PURE__ */ new Set(), S = de(t.attrs);
  te(() => {
    $(Ft(S, m.value));
  });
  function $(u) {
    _.forEach((p) => {
      p(), _.delete(p);
    });
    for (const p in u) {
      const P = ge(p);
      _.add(
        he(
          () => t.attrs[p],
          () => {
            b.props[P] = t.attrs[p];
          }
        )
      );
    }
  }
  if (te(() => {
    const u = Nt(de(t.attrs), m.value);
    "multiple" in u && (u.multiple = U(u.multiple)), typeof u.onBlur == "function" && (u.onBlur = xn(u.onBlur)), b.props.attrs = Object.assign({}, b.props.attrs || {}, u);
  }), te(() => {
    const u = (e.errors ?? []).map(
      (p) => /* @__PURE__ */ K({
        key: kt(p),
        type: "error",
        value: p,
        meta: { source: "prop" }
      })
    );
    b.store.apply(
      u,
      (p) => p.type === "error" && p.meta.source === "prop"
    );
  }), b.type !== "input") {
    const u = `${b.name}-prop`;
    te(() => {
      const p = e.inputErrors ?? {}, P = Object.keys(p);
      P.length || b.clearErrors(!0, u);
      const R = P.reduce((j, M) => {
        let f = p[M];
        return typeof f == "string" && (f = [f]), Array.isArray(f) && (j[M] = f.map(
          (k) => /* @__PURE__ */ K({
            key: k,
            type: "error",
            value: k,
            meta: { source: u }
          })
        )), j;
      }, {});
      b.store.apply(
        R,
        (j) => j.type === "error" && j.meta.source === u
      );
    });
  }
  te(() => Object.assign(b.config, e.config)), b.type !== "input" && cn(_t, b);
  let w;
  return b.on("modelUpdated", () => {
    var u, p;
    t.emit("inputRaw", (u = b.context) == null ? void 0 : u.value, b), y && t.emit("input", (p = b.context) == null ? void 0 : p.value, b), o && b.context && (w = H(b.value), t.emit("update:modelValue", ct(b.value)));
  }), o && (he(
    pn(e, "modelValue"),
    (u) => {
      q(w, u) || b.input(u, !1);
    },
    { deep: !0 }
  ), b.value !== v && b.emit("modelUpdated")), mn(() => b.destroy()), b;
}
var Jl = 1;
function Gl(e) {
  return typeof e == "function" && e.length === 2 || typeof e == "object" && !Array.isArray(e) && !("$el" in e) && !("$cmp" in e) && !("if" in e);
}
function oo(e, t = {}, r = {}) {
  const n = {
    type: "input",
    ...t
  };
  let s;
  if (Gl(e)) {
    const i = `SchemaComponent${Jl++}`;
    s = /* @__PURE__ */ A("input", () => ({
      $cmp: i,
      props: {
        context: "$node.context"
      }
    })), n.library = { [i]: tt(e) };
  } else
    typeof e == "function" ? s = e : s = /* @__PURE__ */ A("input", () => H(e));
  return n.schema = /* @__PURE__ */ sl(s || "Schema undefined", r), n.schemaMemoKey || (n.schemaMemoKey = `${Math.random()}`), n;
}
var Ql = /* @__PURE__ */ A("messages", () => ({
  $el: "ul",
  if: "$fns.length($messages)"
})), Xl = /* @__PURE__ */ A("message", () => ({
  $el: "li",
  for: ["message", "$messages"],
  attrs: {
    key: "$message.key",
    id: "$id + '-' + $message.key",
    "data-message-type": "$message.type"
  }
})), eo = Ql(Xl("$message.value")), uo = /* @__PURE__ */ wt({
  props: {
    node: {
      type: Object,
      required: !1
    },
    sectionsSchema: {
      type: Object,
      default: {}
    },
    defaultPosition: {
      type: [String, Boolean],
      default: !1
    },
    library: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e, t) {
    const r = re(() => e.node || Pe(_t, void 0));
    he(
      r,
      () => {
        var i;
        (i = r.value) != null && i.context && !U(e.defaultPosition) && (r.value.context.defaultMessagePlacement = !1);
      },
      { immediate: !0 }
    );
    const n = eo(e.sectionsSchema || {}), s = re(() => {
      var i, a, l, o, y, v;
      return {
        messages: ((a = (i = r.value) == null ? void 0 : i.context) == null ? void 0 : a.messages) || {},
        fns: ((o = (l = r.value) == null ? void 0 : l.context) == null ? void 0 : o.fns) || {},
        classes: ((v = (y = r.value) == null ? void 0 : y.context) == null ? void 0 : v.classes) || {}
      };
    });
    return () => {
      var i;
      return (i = r.value) != null && i.context ? Ke(
        Ll,
        { schema: n, data: s.value, library: e.library },
        { ...t.slots }
      ) : null;
    };
  }
}), to = /* @__PURE__ */ A("summary", () => ({
  $el: "div",
  attrs: {
    "aria-live": "polite"
  }
})), ro = /* @__PURE__ */ A("summaryInner", () => ({
  $el: "div",
  if: "$summaries.length && $showSummaries"
})), no = /* @__PURE__ */ A("messages", () => ({
  $el: "ul",
  if: "$summaries.length && $showSummaries"
})), so = /* @__PURE__ */ A("message", () => ({
  $el: "li",
  for: ["summary", "$summaries"],
  attrs: {
    key: "$summary.key",
    "data-message-type": "$summary.type"
  }
})), io = /* @__PURE__ */ A("summaryHeader", () => ({
  $el: "h2",
  attrs: {
    id: "$id"
  }
})), ao = /* @__PURE__ */ A("messageLink", () => ({
  $el: "a",
  attrs: {
    id: "$summary.key",
    href: '$: "#" + $summary.id',
    onClick: "$jumpLink"
  }
}));
to(
  ro(
    io("$summaryHeader"),
    no(so(ao("$summary.message")))
  )
);
Ml();
rn();
const fo = {
  global: {
    label: "$reset cursor-pointer text-black dark:text-white formkit-disabled:select-none formkit-disabled:cursor-default",
    help: "text-sm text-base-700 mb-2 mt-1.5",
    message: "dark:text-danger-200 mb-1 text-danger-500 text-xs rounded select-none inline-block",
    messages: "list-none p-0 mt-1 mb-0"
  },
  checkbox: {
    decorator: "relative cursor-pointer formkit-disabled:cursor-default w-5 h-5 mr-2 flex flex-shrink-0 items-center justify-center transition-colors duration-200 border border-base-300 bg-base-100 dark:bg-base-1000 peer-checked:bg-primary-500 peer-checked:border-primary-500",
    decoratorIcon: "flex text-2xl opacity-0 formkit-checked:opacity-100 formkit-checked:text-white",
    outer: "formkit-disabled:opacity-60",
    input: "fixed left-[999em] w-0 h-0 overflow-hidden opacity-0 pointer-events-none peer",
    wrapper: "flex items-center mb-1"
  },
  textarea: {
    label: "font-bold",
    input: "w-full disabled:bg-base-300 disabled:text-base-700",
    inner: "shadow-px shadow-secondary-100 focus:shadow-2px focus:shadow-primary-500"
  },
  radio: {
    legend: "$reset font-bold text-black dark:text-white formkit-disabled:select-none",
    decorator: "relative w-[1.2rem] h-[1.2rem] cursor-pointer formkit-disabled:cursor-default w-5 h-5 rounded-full mr-2 flex flex-shrink-0 items-center justify-center transition-colors duration-200 border border-base-300 bg-base-100 shadow-base-100",
    decoratorIcon: "transition-all duration-200 rounded-full w-[.6rem] h-[.6rem] formkit-checked:bg-white formkit-checked:shadow-[0_0_0_6px_rgba(0,0,0,1)] formkit-checked:shadow-primary-500",
    outer: "formkit-disabled:opacity-60",
    input: "fixed left-[999em] w-0 h-0 overflow-hidden opacity-0 pointer-events-none peer",
    wrapper: "flex items-center mb-1"
  },
  select: {
    label: "font-bold",
    inner: "relative",
    input: "relative w-full p-2 transition-all duration-200 shadow-px shadow-secondary-100 focus:shadow-2px focus:shadow-primary-500 border-0 appearance-none outline-0 dark:bg-base-1000",
    selectIcon: "absolute right-[.5rem] top-2/4 -translate-y-1/2"
  },
  "family:text": {
    label: "font-bold",
    inner: "flex items-center",
    input: "relative w-full p-2 transition-all duration-200 shadow-px shadow-secondary-100 focus:shadow-2px focus:shadow-primary-500 border-0 appearance-none outline-0 max-h-10 dark:bg-base-1000 dark:text-white disabled:bg-base-300 disabled:text-base-700"
  },
  "family:date": {
    label: "font-bold",
    inner: "flex items-center",
    input: "relative w-full p-2 transition-all duration-200 shadow-px shadow-secondary-100 focus:shadow-2px focus:shadow-primary-500 border-0 appearance-none outline-0 max-h-10 dark:bg-base-1000 dark:text-white disabled:bg-base-300 disabled:text-base-700"
  }
};
export {
  Wl as F,
  uo as a,
  oo as c,
  gr as g,
  fo as t
};
//# sourceMappingURL=formkit-7479af46.js.map
